import { Module } from './types';

export const modules: Module[] = [
    {
        title: 'Platzbuchungssystem einfach und voll automatisiert',
        slug: 'platzbuchungen',
        moduleNameKey: 'spacebookingtool',
        seo: {
            title: 'Platzbuchung für Tennis, Padel & Sportvereine | Sportision',
            description:
                'Optimiere deine Platzvergabe für Tennis, Padel & weitere Sportarten: Online-Buchung, Bezahlung & Zutrittssteuerung. Mehr Auslastung. Jetzt entdecken!',
            keywords: [
                'platzbuchungssystem',
                'platzbuchung',
                'platzbelegung software',
                'tennis buchungssystem',
                'padel buchungssystem',
                'sportverein software',
                'sportstätte verwaltung',
                'online buchung',
                'platzreservierung',
                'zutrittskontrolle',
                'lichtsteuerung',
                'padel buchung',
                'online zahlung'
            ]
        },
        description:
            'Das Platzbuchungssystem für Sportvereine und Sportstätten: Online Buchung, Terminal vor Ort, flexible Buchungsregeln, Preissteuerung, Online Zahlung sowie Licht und Zutrittssteuerung für weniger Aufwand und mehr Auslastung.',
        image: '/images/modules/space_manager.png',
        relatedSlugs: ['rechnungen', 'mitgliederverwaltung', 'app'],

        functions: [
            {
                name: 'Echtzeit-Belegungsplan',
                descriptionShort: 'Übersicht über freie und belegte Plätze',
                descriptionLong:
                    'Der Echtzeit-Belegungsplan zeigt jederzeit aktuell, welche Tennisplätze verfügbar oder bereits belegt sind. Durch die Live-Aktualisierung werden Doppelbuchungen vermieden und die Platznutzung im Tennisverein optimal gesteuert. Mitglieder, Trainer und Verwaltung profitieren von maximaler Transparenz und einer effizienten Organisation der Platzbelegung.'
            },
            {
                name: 'Serien- und Abo-Buchungen',
                descriptionShort: 'Wiederkehrende Termine automatisch buchen',
                descriptionLong:
                    'Mit Serien- und Abo-Buchungen können feste Spielzeiten, Trainings oder Hallenabos langfristig im System hinterlegt werden. Tennisvereine profitieren von planbarer Auslastung, während Mitglieder ihre Wunschzeiten dauerhaft sichern. Ideal für regelmäßiges Spielen, Trainerstunden und langfristige Platznutzung.'
            },
            {
                name: 'Mitgliederverwaltung',
                descriptionShort: 'Mitgliederverwaltung über das Mitglieder-Modul',
                descriptionLong:
                    'Die Mitgliederverwaltung erfolgt über ein eigenes Mitglieder-Modul, das die zentrale Pflege von Mitgliedsdaten, Rollen, Abteilungen und Kategorien ermöglicht. Buchungsregeln greifen direkt auf diese Daten zu, etwa für Mitgliederpreise oder Buchungsrechte.'
            },
            {
                name: 'Gastbuchungen',
                descriptionShort: 'Buchungen für Nicht-Mitglieder',
                descriptionLong:
                    'Die Gastbuchungsfunktion erlaubt es Nicht-Mitgliedern, Tennisplätze zu buchen und direkt zu bezahlen. Dadurch steigern Tennisvereine die Auslastung ihrer Anlage, gewinnen neue Spieler und generieren zusätzliche Einnahmen durch flexible Gastspielangebote.'
            },
            {
                name: 'Online-Zahlungsabwicklung',
                descriptionShort: 'Digitale Zahlungen integriert',
                descriptionLong:
                    'Die Online-Zahlungsabwicklung integriert moderne Zahlungsarten wie PayPal, SEPA-Lastschrift, Kreditkarte oder Apple Pay. Zahlungen für Buchungen, Gastspiele oder Abos werden automatisiert verarbeitet und sorgen für sichere sowie transparente Zahlungsprozesse im Tennisverein. Per Regel machst du Online-Zahlung für bestimmte Plätze, Zeiten oder Personengruppen verpflichtend und gibst bei Bedarf die Zahlungsart vor.'
            },
            {
                name: 'Mehrere Zahlungskonten',
                descriptionShort: 'Einnahmen dem richtigen Konto zuordnen',
                descriptionLong:
                    'Verbinde mehrere Konten für Online-Zahlungen und ordne sie Bereichen zu, etwa Platzbuchungen auf ein anderes Konto als Kurse. Ein Standardkonto fängt alles andere auf.'
            },
            {
                name: 'Rechnungs- und Abrechnungssystem',
                descriptionShort: 'Automatische Rechnungen und Abos',
                descriptionLong:
                    'Das Rechnungs- und Abrechnungssystem erstellt automatisch Rechnungen für Platzbuchungen, Abonnements, Gastspiele und Trainings. Es unterstützt Tennisvereine bei einer effizienten Finanzverwaltung und sorgt für eine klare, nachvollziehbare Abrechnung.'
            },
            {
                name: 'Buchungsregeln und Kontingente',
                descriptionShort: 'Flexible Regeln pro Mitglied',
                descriptionLong:
                    'Individuelle Buchungsregeln definieren Zeitlimits, maximale Buchungen oder unterschiedliche Rechte für Mitglieder, Gäste und Trainer. So wird eine faire Platzverteilung sichergestellt und die Nutzung der Tennisplätze optimal gesteuert.'
            },
            {
                name: 'Platzsperren und Blockzeiten',
                descriptionShort: 'Plätze zeitweise sperren',
                descriptionLong:
                    'Mit Platzsperren und Blockzeiten lassen sich Tennisplätze gezielt für Turniere, Wartungsarbeiten oder Vereinsveranstaltungen reservieren. Die Sperrungen werden klar im System angezeigt und verhindern fehlerhafte Buchungen. Geschlossene Tage, etwa an Feiertagen, sind im Kalender sichtbar und lassen keine Buchungen zu.'
            },
            {
                name: 'Konflikte beim Überbuchen auflösen',
                descriptionShort: 'Vorrang für wichtige Termine',
                descriptionLong:
                    'Muss ein Turnier oder Training auf bereits gebuchte Plätze, entscheidest du für jede betroffene Buchung, ob sie im Hintergrund bestehen bleibt, storniert oder gelöscht wird. Verknüpfte Plätze werden dabei mitgeprüft.'
            },
            {
                name: 'Buchungslinks',
                descriptionShort: 'Feste Termine per Link vergeben',
                descriptionLong:
                    'Erzeuge einen einmaligen Buchungslink mit festem Zeitfenster, zum Beispiel für ein Probetraining oder einen Firmenkunden. Auf Wunsch gelten die normalen Buchungsregeln für diesen Link nicht. Eingelöst wird er auf einer öffentlichen Seite.'
            },
            {
                name: 'Mobile App und Responsive Web',
                descriptionShort: 'Nutzung auf allen Geräten',
                descriptionLong:
                    'Eine mobile App oder eine responsive Weboberfläche ermöglicht die Nutzung des Systems auf Smartphone, Tablet und Desktop. Mitglieder können Buchungen bequem unterwegs verwalten und bleiben jederzeit über ihre Spielzeiten informiert.'
            },
            {
                name: 'Push- und E-Mail-Benachrichtigungen',
                descriptionShort: 'Automatische Erinnerungen',
                descriptionLong:
                    'Push-Nachrichten und E-Mail-Benachrichtigungen informieren Mitglieder automatisch über Buchungen, Stornierungen und Änderungen. So wissen alle Beteiligten sofort Bescheid.'
            },
            {
                name: 'Vereinskommunikation und News',
                descriptionShort: 'Zentrale Vereinsinfos',
                descriptionLong:
                    'Die integrierte Vereinskommunikation bündelt News, Ankündigungen und wichtige Informationen an einem zentralen Ort. Tennisvereine stärken damit das Vereinsleben, verbessern die interne Kommunikation und erhöhen die Mitgliederbindung.'
            },
            {
                name: 'Turniere, Kurse und Events',
                descriptionShort: 'Veranstaltungen digital organisieren',
                descriptionLong:
                    'Turniere, Trainings, Kurse und Events lassen sich digital planen, verwalten und abrechnen. Teilnehmer melden sich online an, und der organisatorische Aufwand sinkt deutlich.'
            },
            {
                name: 'Zutritts- und Lichtsteuerung',
                descriptionShort: 'Automatisierte Anlagensteuerung',
                descriptionLong:
                    'Die automatische Steuerung von Türen, Licht und Heizung koppelt Buchungen direkt mit der Infrastruktur der Tennisanlage. Plätze werden nur bei aktiven Buchungen freigeschaltet, was Energiekosten senkt und den Betrieb effizienter macht.'
            },
            {
                name: 'Digitales Türöffnen mit KleverKey',
                descriptionShort: 'Tür per App öffnen',
                descriptionLong:
                    'Mit der KleverKey-Anbindung öffnen Mitglieder die Tür per App oder Link. Digitale Schlüssel werden bei Buchungsänderungen automatisch deaktiviert, und jede Öffnung wird protokolliert.'
            },
            {
                name: 'Rollen und Berechtigungen',
                descriptionShort: 'Unterschiedliche Nutzerrollen',
                descriptionLong:
                    'Ein Rollen- und Rechtesystem definiert klar, welche Funktionen Administratoren, Trainer, Mitglieder oder Gäste nutzen dürfen. Dies sorgt für Sicherheit, klare Zuständigkeiten und eine strukturierte Vereinsverwaltung.'
            },
            {
                name: 'Statistiken und Auswertungen',
                descriptionShort: 'Analyse der Platznutzung',
                descriptionLong:
                    'Statistiken und Auswertungen liefern detaillierte Einblicke in Auslastung, Buchungsverhalten und Einnahmen. Tennisvereine können diese Daten nutzen, um Platzbelegung, Preise und Angebote gezielt zu optimieren.'
            },
            {
                name: 'Branding und Individualisierung',
                descriptionShort: 'Anpassung an Vereinsdesign',
                descriptionLong:
                    'Mit der Vereinswebsite aus Sportision gestaltest du Farben, Schriften und Logo im eigenen Design. Der Belegungsplan lässt sich direkt in die Website einbinden und sorgt für einen professionellen Außenauftritt.'
            },
            {
                name: 'Exporte',
                descriptionShort: 'Datenexporte für Verwaltung und Abrechnung',
                descriptionLong:
                    'Exportfunktionen ermöglichen den einfachen Export von Buchungen, Mitgliederdaten und Abrechnungen. Tennisvereine können diese Daten flexibel archivieren oder für externe Auswertungen und Verwaltungsprozesse weiterverwenden.'
            }
        ],
        sections: [
            {
                title: 'Online buchen, bezahlen & Zutritt automatisch steuern',
                highlight: 'box',
                description:
                    'Sportision ist mehr als ein Platzbuchungssystem, es ist die zentrale Plattform für effizientes Vereins- und Anlagenmanagement. Von der fairen Platzverteilung über digitale Abrechnung bis hin zur automatisierten Licht- und Zutrittssteuerung: Sportision verbindet alle wichtigen Prozesse in einem System. Vereine, Sportanlagen und Betreiber profitieren von mehr Auslastung, weniger Verwaltungsaufwand und zufriedeneren Mitgliedern. Dank klarer Buchungsregeln, transparenter Belegungspläne und logikbasierter Automatisierung läuft der Betrieb zuverlässig im Hintergrund, während sich dein Team auf das Wesentliche konzentrieren kann: Sport, Gemeinschaft und Wachstum. Ob Tennis, Padel oder andere Sportarten: Sportision passt sich flexibel an eure Anforderungen an und wächst mit eurem Verein. Modern, zuverlässig und einfach zu bedienen für Mitglieder, Trainer und Verwaltung gleichermaßen.'
            },
            {
                title: 'Grundausstattung',
                description: 'Schnell Plätze finden, fair buchen für volle Transparenz auf allen Plätzen.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Echtzeit-Belegungsplan & Platzbelegung online',
                        description:
                            'Der Live-Belegungsplan zeigt freie und belegte Zeiten sofort an. Die Platzbelegung erfolgt komplett online, sodass Doppelbuchungen vermieden werden und Mitglieder auf einen Blick sehen, wann Tennis- oder Padelplätze verfügbar sind.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Buchungsregeln & Kontingente',
                        description:
                            'Lege flexible Buchungsregeln fest: Zeitlimits, maximale Buchungen sowie unterschiedliche Rechte für Mitglieder, Gäste oder Trainer. So bleibt die Platzverteilung fair und die Auslastung optimal.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Platzsperren & Blockzeiten',
                        description:
                            'Sperre Plätze für Turniere, Wartung oder Vereinsveranstaltungen. Blockzeiten werden klar angezeigt und verhindern Fehlbuchungen im laufenden Betrieb.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Serien- & Abo-Buchungen',
                        description:
                            'Hinterlege wiederkehrende Termine für Stammspieler, Training oder Hallenabos. Dies führt zu mehr Planbarkeit für den Verein und bietet mehr Komfort für Mitglieder.'
                    }
                ]
            },
            {
                title: 'Für den Vereinsalltag',
                description: 'Ausnahmen gehören dazu. Sportision macht sie einfach.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Buchungslinks',
                        description:
                            'Vergib einen festen Termin per Link, etwa für ein Probetraining oder einen Firmenkunden. Auf Wunsch ohne die üblichen Buchungsregeln.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Konflikte gezielt auflösen',
                        description:
                            'Beim Überbuchen entscheidest du pro Buchung: im Hintergrund behalten, stornieren oder löschen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Geschlossene Tage',
                        description: 'Feiertage und Schließtage sind im Kalender sichtbar und lassen keine Buchungen zu.'
                    }
                ]
            },

            {
                title: 'Mitglieder & Rollen',
                description: 'Struktur im Verein: mit klaren Rollen, Rechten und Daten im Griff.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Mitgliederverwaltung über das Mitglieder-Modul',
                        description:
                            'Verwalte Mitgliedsdaten zentral mit Rollen, Abteilungen und Kategorien. Das Mitglieder-Modul reduziert Verwaltungsaufwand und schafft Transparenz für Vorstand, Trainer und Team.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Rollen & Berechtigungen',
                        description:
                            'Definiere, wer was darf: Admins, Trainer, Mitglieder oder Gäste. Das Rechtesystem sorgt für Sicherheit, klare Zuständigkeiten und eine saubere Vereinsorganisation.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Gastbuchungen',
                        description:
                            'Ermögliche Gastspiel-Buchungen mit klaren Regeln und sauberer Abrechnung. Dies sorgt für mehr Auslastung, neue Spieler und zusätzliche Einnahmen ohne Mehraufwand.'
                    }
                ]
            },
            {
                title: '"Alles ist Möglich" - Regeleditor',
                description:
                    'Individuelle Buchungsregeln für deinen Verein, flexibel anpassbar und einfach zu verwalten.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Bedingungen & Aktionen',
                        description:
                            'Erstelle komplexe Buchungsregeln mit einfachen Bausteinen. Definiere Bedingungen wie zum Beispiel Mitgliedstyp, Uhrzeit oder Platzart sowie Aktionen wie Preisänderung oder Buchungslimit. So passt du das System exakt an die Bedürfnisse deines Vereins an.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Testmodus & Vorschau',
                        description:
                            'Teste deine Buchungsregeln vor der Aktivierung, indem du verschiedene Szenarien simulierst und überprüfst, wie das System reagiert. So vermeidest du Fehler und stellst sicher, dass alles wie gewünscht funktioniert.'
                    },
                    {
                        type: 'imageCard',
                        image: '/images/modules/space_manager_rule_form.png'
                    }
                ]
            },

            {
                title: 'Zahlung & Abrechnung',
                description: 'Weniger Aufwand, verlässliche Einnahmen: digital bezahlen und automatisch abrechnen.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Online-Zahlungsabwicklung',
                        description:
                            'Integriere moderne Zahlarten wie PayPal, SEPA, Kreditkarte oder Wallets. Per Regel machst du Online-Zahlung für bestimmte Plätze oder Zeiten verpflichtend und gibst die Zahlungsart vor.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Rechnungs- & Abrechnungssystem',
                        description:
                            'Automatische Rechnungen für Buchungen, Abonnements, Gastspiele und Training. Alle Vorgänge bleiben nachvollziehbar, was perfekt für eine effiziente Vereins- und Finanzverwaltung ist.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Weniger No-Shows, mehr Planbarkeit',
                        description:
                            'Digitale Zahlung plus automatische Infos erhöhen die Verbindlichkeit, reduzieren Ausfälle und machen Umsätze verlässlicher.'
                    }
                ]
            },

            {
                title: 'Automatisierung',
                description: 'Mehr Auslastung, weniger Aufwand mit Licht- und Zutrittssteuerung.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Zutritts- & Lichtsteuerung',
                        description:
                            'Kopple Buchungen mit der Infrastruktur, sodass sich Türen, Licht und optional die Heizung automatisch steuern. Das senkt Energiekosten, reduziert manuelle Arbeit und macht den Betrieb zuverlässiger.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Digitales Türöffnen mit KleverKey',
                        description:
                            'Mitglieder öffnen die Tür per App oder Link. Schlüssel passen sich an Buchungsänderungen an, jede Öffnung ist protokolliert.'
                    },
                    {
                        type: 'imageCard',
                        image: '/images/modules/space_control.png'
                    }
                ]
            },
            {
                title: 'Kommunikation',
                description: 'Alle Mitglieder erreichen, mit News, Updates und automatischen Benachrichtigungen.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Push- & E-Mail-Benachrichtigungen',
                        description:
                            'Automatische Erinnerungen zu Buchungen, Änderungen oder wichtigen Infos. Dies führt zu weniger Rückfragen, weniger vergessenen Terminen und besserer Planbarkeit im Club.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Vereinskommunikation & News',
                        description:
                            'Zentrale Vereinsinfos an einem Ort wie Ankündigungen, Updates und Hinweise. Dies stärkt das Vereinsleben und sorgt dafür, dass Informationen wirklich ankommen.'
                    }
                ]
            },
            {
                title: 'Insights',
                description: 'Auslastung verstehen, Angebot verbessern und Entscheidungen datenbasiert treffen.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Statistiken & Auswertungen',
                        description:
                            'Analysiere Auslastung, Buchungsverhalten und Einnahmen. So optimierst du Platzbelegung, Zeiten, Regeln und Angebote für einen wirtschaftlich starken Vereinsbetrieb.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Optimierung statt Bauchgefühl',
                        description:
                            'Mit klaren Zahlen erkennst du Engpässe, beliebte Zeiten und Potenziale für neue Angebote oder bessere Auslastung, was besonders in der Winter- und Hallensaison wertvoll ist.'
                    }
                ]
            },

            {
                title: 'Brand & Daten',
                description: 'Professioneller Auftritt nach außen, und Daten sauber exportieren nach innen.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Branding & Individualisierung',
                        description:
                            'Gestalte deine Vereinswebsite mit eigenen Farben, Schriften und Logo und binde den Belegungsplan direkt ein. So wirkt die Buchung wie ein Teil eures Auftritts.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Exporte',
                        description:
                            'Exportiere Buchungen, Mitgliederdaten oder Abrechnungen für die Archivierung und Weiterverarbeitung. Dies ist ideal für die Vereinsverwaltung, Buchhaltung und interne Auswertungen.'
                    }
                ]
            },

            {
                title: 'Mobile Nutzung',
                description: 'Für Mitglieder gemacht: einfach, schnell und überall verfügbar.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Mobile App & Responsive Web',
                        description:
                            'Optimiert für Smartphone, Tablet und Desktop: Mitglieder verwalten Buchungen unterwegs, prüfen die Belegung in Echtzeit und bleiben durch Benachrichtigungen immer auf dem neuesten Stand.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Ein System für alle Geräte',
                        description:
                            'Egal ob iPhone, Android oder Desktop: Die Nutzung bleibt intuitiv, was perfekt für modernes Vereinsmanagement und eine reibungslose Platzorganisation ist.'
                    }
                ]
            },
            {
                title: 'FAQ zur Platzbuchung im Sportverein',
                description: 'Kurz erklärt: Platzbuchung, Regeln und Ablauf im Vereinsalltag.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Was ist ein Platzbuchungssystem für Sportvereine?',
                        description:
                            'Ein Platzbuchungssystem digitalisiert die Platzbuchung im Sportverein. Mitglieder buchen online, Regeln und Kontingente werden automatisch geprüft, und die Belegung ist jederzeit transparent.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Wie läuft die Platzbuchung im Sportverein mit Sportision ab?',
                        description:
                            'Ein Platzbuchungssystem verhindert Doppelbuchungen durch einen Echtzeit-Belegungsplan. Sobald ein Platz gebucht wird, wird er sofort für alle anderen Nutzer gesperrt.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Kann ich Gastbuchungen und Online-Zahlungen anbieten?',
                        description:
                            'Ja, Gastbuchungen sind möglich und können direkt online bezahlt werden. Das entlastet die Verwaltung und steigert die Auslastung der Sportanlage.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Wie verhindert man Doppelbuchungen und Konflikte?',
                        description:
                            'Der Echtzeit-Belegungsplan und klare Buchungsregeln verhindern Überschneidungen. Buchungen werden sofort gesperrt und sind für alle sichtbar.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Eignet sich das System für die Verwaltung von Tennisbuchungen über das Internet?',
                        description:
                            'Ja, Sportision ist ideal für die Verwaltung von Tennisbuchungen über das Internet. Mitglieder können Asche- oder Hallenplätze bequem per Smartphone oder PC online buchen. Gleichzeitig eignet sich die Software auch hervorragend für Padel, Squash oder multifunktionale Sportanlagen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Wie funktioniert die Platzbelegung online genau?',
                        description:
                            'Mitglieder sehen freie Zeiten im digitalen Belegungsplan, wählen ihren Tennis- oder Padelplatz und bestätigen die Buchung. Preisregeln, Mitgliedsstatus und Sperrzeiten greifen automatisch, damit die Platzvergabe fair bleibt.'
                    }
                ]
            }
        ]
    },
    {
        title: 'Abrechnung & Buchhaltung für Vereine und Sportschulen',
        slug: 'rechnungen',
        moduleNameKey: 'invoicetool',
        seo: {
            title: 'Abrechnung & Buchhaltung für Vereine & Sportschulen | Sportision',
            description:
                'Beiträge abrechnen, per SEPA einziehen, Zahlungen zuordnen und automatisch buchen, bis zu BWA, EÜR und UStVA. Für Vereine und Sportschulen. Jetzt entdecken!',
            keywords: [
                'Abrechnungssoftware Sportverein',
                'Abrechnungssoftware Sportschule',
                'Buchhaltungssoftware Verein',
                'Buchhaltungssoftware Sportschule',
                'Buchhaltung Tennisschule',
                'Buchhaltung Kampfsportschule',
                'Beitragsabrechnung Software',
                'Beitragseinzug SEPA',
                'Bankabgleich Software',
                'Offene Posten',
                'Mahnwesen Software',
                'EÜR Software',
                'BWA',
                'Umsatzsteuervoranmeldung',
                'SKR 42',
                'Belegerfassung KI',
                'DATEV Export'
            ]
        },
        description:
            'Von der Beitragsrechnung bis zur BWA in einem System: Sportision rechnet Beiträge, Kurse und Buchungen ab, zieht per SEPA-Lastschrift ein, ordnet Zahlungseingänge zu und bucht alles automatisch. Für Vereine genauso wie für Tennisschulen, Kampfsportschulen und andere Sportanbieter.',
        image: '/images/modules/invoices.png',
        relatedSlugs: ['mitgliederverwaltung', 'platzbuchungen', 'trainerstunden', 'reiten'],

        functions: [
            {
                name: 'SEPA-Lastschrift & Mandatsverwaltung',
                descriptionShort: 'Automatisierter Bankeinzug',
                descriptionLong:
                    'Sportision automatisiert den Einzug per SEPA-Lastschrift. Mandatsreferenzen und Gläubiger-ID werden zentral verwaltet, SEPA-XML-Dateien für die Bank automatisch erzeugt und Pre-Notifications rechtzeitig per E-Mail versendet.'
            },
            {
                name: 'SEPA-Läufe mit Protokoll',
                descriptionShort: 'Jeder Einzug nachvollziehbar',
                descriptionLong:
                    'Jeder Lastschriftlauf wird mit seinen Dateien, Beträgen und enthaltenen Rechnungen gespeichert. SEPA-Dateien lassen sich später erneut herunterladen, und bereits bezahlte Rechnungen werden nicht noch einmal eingezogen.'
            },
            {
                name: 'Beitragsmatrix & Tarife',
                descriptionShort: 'Flexible Beitrags- und Preisstrukturen',
                descriptionLong:
                    'Vom Grundbeitrag über Sparten- und Kursgebühren bis zu Aufnahmegebühren oder Sondertarifen: Sportision bildet auch komplexe Modelle ab. Mehrfachzugehörigkeiten werden erkannt und korrekt verrechnet.'
            },
            {
                name: 'Familien & Abrechnungsgruppen',
                descriptionShort: 'Gemeinsam oder getrennt abrechnen',
                descriptionLong:
                    'Familien werden in einer Abrechnungsgruppe zusammengefasst. Ein zentraler Zahler erhält eine gemeinsame Rechnung, auf Wunsch mit einer Obergrenze für die ganze Familie. Alternativ bekommt jedes Familienmitglied eine eigene Rechnung.'
            },
            {
                name: 'Altersgesteuerte Tarifwechsel',
                descriptionShort: 'Automatische Anpassung',
                descriptionLong:
                    'Beiträge passen sich automatisch an, sobald definierte Altersgrenzen erreicht sind, etwa beim Wechsel vom Jugend- in den Erwachsenentarif.'
            },
            {
                name: 'Anteilige Abrechnung bei Kündigung und Pause',
                descriptionShort: 'Fair abrechnen statt pauschal',
                descriptionLong:
                    'Endet oder ruht eine Mitgliedschaft unterm Jahr, berechnet Sportision den Beitrag auf Wunsch anteilig, monatlich oder tagesgenau. Alternativ fällt der Zeitraum komplett aus der Abrechnung.'
            },
            {
                name: 'Rechnungslauf mit Vorschau',
                descriptionShort: 'Hunderte Rechnungen in einem Lauf',
                descriptionLong:
                    'Mit einem Rechnungslauf erstellst du Beitrags-, Kurs- und Gebührenrechnungen auf einmal und verschickst sie als PDF per E-Mail. Eine Vorschau zeigt vorher, wer was bezahlen soll.'
            },
            {
                name: 'Offene Posten & Mahnwesen',
                descriptionShort: 'Wer schuldet was',
                descriptionLong:
                    'Die Offene-Posten-Liste zeigt alle unbezahlten Rechnungen je Zahler oder Abrechnungsgruppe. Zahlungserinnerungen und Mahnungen in mehreren Stufen erstellst du gesammelt, mit festen oder prozentualen Mahngebühren.'
            },
            {
                name: '10er-Karten & Guthaben',
                descriptionShort: 'Prepaid-Abrechnung',
                descriptionLong:
                    'Prepaid-Modelle wie 10er-Karten oder Guthabenkonten werden automatisch verwaltet. Bei jeder Teilnahme wird der Betrag oder eine Einheit vom Guthaben abgezogen.'
            },
            {
                name: 'Bankabgleich',
                descriptionShort: 'Zahlungen automatisch zuordnen',
                descriptionLong:
                    'Kontoumsätze kommen automatisch zu Sportision und werden passenden offenen Rechnungen vorgeschlagen. Doppelte Buchungen werden erkannt und SEPA-Einzüge bestätigt. Zahlungen ohne Rechnung, etwa Bankgebühren oder Zuschüsse, buchst du direkt aus dem Umsatz. CAMT-Kontoauszüge lassen sich ebenso importieren.'
            },
            {
                name: 'Mehrere Zahlungskonten',
                descriptionShort: 'Geld landet im richtigen Konto',
                descriptionLong:
                    'Für Online-Zahlungen kannst du mehrere Konten verbinden und einzelnen Bereichen zuordnen, zum Beispiel Platzbuchungen auf ein anderes Konto als Kursgebühren.'
            },
            {
                name: 'Automatische Buchungen',
                descriptionShort: 'Rechnungen und Zahlungen buchen sich selbst',
                descriptionLong:
                    'Jede Rechnung und jede Zahlung aus Sportision wird automatisch im Journal gebucht, mit Konto, Gegenkonto und Steuerschlüssel. Nichts muss ein zweites Mal erfasst werden.'
            },
            {
                name: 'Belegerfassung mit KI',
                descriptionShort: 'Hochladen oder fotografieren, fertig',
                descriptionLong:
                    'Eingangsrechnungen lädst du hoch oder fotografierst sie mit dem Handy. Die KI liest Rechnungsnummer, Datum, Fälligkeit, Betrag, Steuern und Bankverbindung aus und schlägt ein Konto vor.'
            },
            {
                name: 'Kontenrahmen SKR 03, SKR 04 und SKR 42',
                descriptionShort: 'Für Vereine und Unternehmen',
                descriptionLong:
                    'Sportschulen und andere Unternehmen arbeiten meist mit SKR 03 oder SKR 04, gemeinnützige Vereine oft mit SKR 42. Die wichtigsten Konten legt Sportision automatisch an, und ein Assistent stellt auch nachträglich auf einen anderen Kontenrahmen um.'
            },
            {
                name: 'Steuerschlüssel & Umsatzsteuer',
                descriptionShort: 'Steuer richtig zuordnen',
                descriptionLong:
                    'Jedes Konto kann einen Standard-Steuerschlüssel haben, jede Buchung trägt ihren eigenen. Kleinunternehmer und steuerbefreite Bereiche lassen sich ebenfalls abbilden.'
            },
            {
                name: 'Manuelle Buchungen & Storno',
                descriptionShort: 'Für alles, was nicht automatisch läuft',
                descriptionLong:
                    'Umbuchungen, Abschreibungen oder Korrekturen erfasst du als manuelle Buchung. Fehler werden storniert statt gelöscht, damit das Journal lückenlos bleibt.'
            },
            {
                name: 'Journal & Kontenblätter',
                descriptionShort: 'Jede Buchung nachvollziehbar',
                descriptionLong:
                    'Das Journal zeigt alle Buchungen in zeitlicher Reihenfolge, das Kontenblatt jedes einzelne Konto mit Saldovortrag.'
            },
            {
                name: 'Eröffnungsbilanz',
                descriptionShort: 'Sauber starten',
                descriptionLong:
                    'Beim Umstieg übernimmst du die Anfangsbestände als Eröffnungsbilanz. Sportision macht dir dafür einen Vorschlag, den du prüfen und anpassen kannst. Offene Rechnungen aus dem Altsystem übernimmst du per Import.'
            },
            {
                name: 'Mehrere Buchungskreise',
                descriptionShort: 'Getrennte Buchhaltungen in einem System',
                descriptionLong:
                    'Mit Mandanten führst du getrennte Buchhaltungen, etwa für Verein und Förderverein oder für mehrere Standorte einer Sportschule. Jeder Mandant hat eigene Konten, einen eigenen Kontenrahmen und eigene Auswertungen.'
            },
            {
                name: 'Kostenstellen',
                descriptionShort: 'Bereiche einzeln auswerten',
                descriptionLong:
                    'Ordne Einnahmen und Ausgaben Kostenstellen zu, zum Beispiel Sparten, Kursen, Turnieren oder Projekten, und sieh auf einen Blick, welcher Bereich trägt.'
            },
            {
                name: 'BWA, EÜR & Bilanz',
                descriptionShort: 'Auswertungen auf Knopfdruck',
                descriptionLong:
                    'Die BWA zeigt Erlöse, Kosten und Ergebnis für jeden Zeitraum. Die EÜR ermittelt Einnahmen und Überschuss nach dem Zuflussprinzip, und wer bilanziert, bekommt die Bilanz direkt aus den Buchungen.'
            },
            {
                name: 'Umsatzsteuer-Voranmeldung',
                descriptionShort: 'Kennzahlen fertig berechnet',
                descriptionLong:
                    'Die Werte für die Umsatzsteuer-Voranmeldung berechnet Sportision aus den Buchungen, sortiert nach Kennzahlen, und zeigt die nächste Abgabefrist. Übertragen wird über ELSTER oder deinen Steuerberater.'
            },
            {
                name: 'Export für den Steuerberater',
                descriptionShort: 'DATEV und CSV',
                descriptionLong:
                    'Buchungen gehen im DATEV-Format direkt in die Kanzleisoftware des Steuerberaters. Alle Auswertungen lassen sich zusätzlich als CSV exportieren.'
            },
            {
                name: 'Rechnungsarchiv im Profil',
                descriptionShort: 'Download-Center für Mitglieder und Kunden',
                descriptionLong:
                    'Mitglieder und Kunden laden ihre Rechnungen jederzeit selbst im Profil herunter und begleichen offene Beträge online.'
            }
        ],
        sections: [
            {
                title: 'Von der Rechnung bis zur BWA in einem System',
                highlight: 'box',
                description:
                    'Ob Verein, Tennisschule oder Kampfsportschule: Abrechnung und Buchhaltung kosten im Alltag die meiste Zeit, und oft wird alles zweimal erfasst. Einmal beim Abrechnen und dann noch einmal in der Buchhaltung oder beim Steuerberater. Bei Sportision entstehen die Buchungen dort, wo das Geld bewegt wird. Beiträge und Kursgebühren werden nach deinen Regeln berechnet, per SEPA eingezogen und automatisch gebucht. Zahlungseingänge ordnet das System den offenen Rechnungen zu, Eingangsbelege liest die KI aus. Am Ende stehen BWA, EÜR, Bilanz und Umsatzsteuer-Voranmeldung bereit, und der Steuerberater bekommt seine Daten im DATEV-Format.'
            },
            {
                title: 'Beiträge & Abrechnung',
                description: 'Auch komplexe Beitrags- und Preismodelle abbilden, automatisch und nachvollziehbar.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'SEPA-Lastschrift & Mandatsverwaltung',
                        description:
                            'Mandate zentral verwalten, SEPA-XML-Dateien automatisch erzeugen und Pre-Notifications rechtzeitig per E-Mail versenden.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Beitragsmatrix & Tarife',
                        description:
                            'Grundbeitrag, Sparten- und Kursgebühren, Aufnahmegebühren und Sondertarife. Mehrfachzugehörigkeiten werden korrekt verrechnet.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Familien- & Alterslogiken',
                        description:
                            'Familien zahlen gemeinsam mit Obergrenze oder bekommen getrennte Rechnungen. Altersgesteuerte Tarifwechsel laufen automatisch.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Anteilig bei Kündigung und Pause',
                        description:
                            'Endet oder ruht eine Mitgliedschaft unterm Jahr, wird der Beitrag monatlich oder tagesgenau anteilig berechnet.'
                    }
                ]
            },
            {
                title: 'Rechnungen & offene Posten',
                description: 'Zahlungsprozesse digitalisieren und Zahlungsausfälle reduzieren.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Rechnungslauf mit Vorschau',
                        description:
                            'Hunderte Rechnungen in einem Lauf, per E-Mail als PDF. Die Vorschau zeigt vorher, wer was bezahlen soll.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Offene-Posten-Liste',
                        description:
                            'Alle unbezahlten Rechnungen je Zahler oder Abrechnungsgruppe, mit Mahnstufe und Summe.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Mahnwesen in Stufen',
                        description:
                            'Zahlungserinnerungen und Mahnungen gesammelt erstellen, mit festen oder prozentualen Mahngebühren.'
                    }
                ]
            },
            {
                title: 'Zahlungseingänge & Bankabgleich',
                description: 'Kontoauszüge abtippen war gestern.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Bankabgleich mit Vorschlägen',
                        description:
                            'Kontoumsätze werden offenen Rechnungen vorgeschlagen. Bankgebühren, Zuschüsse und andere Zahlungen ohne Rechnung buchst du direkt aus dem Umsatz.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'SEPA-Läufe mit Protokoll',
                        description:
                            'Jeder Lastschriftlauf ist mit Dateien, Beträgen und Rechnungen gespeichert. Bezahlte Rechnungen werden nicht doppelt eingezogen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Mehrere Zahlungskonten',
                        description:
                            'Online-Zahlungen landen dort, wo sie hingehören: Ordne Bereiche wie Platzbuchungen oder Kurse eigenen Konten zu.'
                    },
                    {
                        type: 'imageCard',
                        image: '/images/modules/invoice_form.png'
                    }
                ]
            },
            {
                title: 'Buchen ohne Abtippen',
                description: 'Die meisten Buchungen entstehen automatisch.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Automatische Buchungen',
                        description:
                            'Rechnungen und Zahlungen werden mit Konto, Gegenkonto und Steuerschlüssel gebucht, sobald sie entstehen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Belegerfassung mit KI',
                        description:
                            'Beleg hochladen oder mit dem Handy fotografieren. Die KI liest Betrag, Datum, Steuern und Bankverbindung aus und schlägt das Konto vor.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Storno statt Löschen',
                        description:
                            'Korrekturen laufen über Stornobuchungen. Das Journal bleibt lückenlos, jede Änderung bleibt sichtbar.'
                    }
                ]
            },
            {
                title: 'Sauber aufgesetzt',
                description: 'Kontenrahmen, Steuern und Anfangsbestände so, wie dein Steuerberater es erwartet.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'SKR 03, SKR 04 oder SKR 42',
                        description:
                            'Der passende Kontenrahmen für Sportschule oder Verein. Ein Wechsel ist auch später noch möglich.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Steuerschlüssel',
                        description:
                            'Standard-Steuerschlüssel pro Konto, abweichende Steuer pro Buchung. Kleinunternehmer und steuerbefreite Bereiche inklusive.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Eröffnungsbilanz',
                        description: 'Anfangsbestände beim Umstieg übernehmen, mit einem Vorschlag, den du nur noch prüfst.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Mehrere Buchungskreise',
                        description:
                            'Verein und Förderverein oder mehrere Standorte getrennt buchen, jeweils mit eigenen Konten und Auswertungen.'
                    }
                ]
            },
            {
                title: 'Auswertungen auf Knopfdruck',
                description: 'Wissen, wo du stehst, nicht erst beim Jahresabschluss.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'BWA',
                        description: 'Erlöse, Kosten und Ergebnis für jeden Monat und jedes Jahr.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'EÜR',
                        description: 'Einnahmen, Ausgaben und Überschuss nach dem Zuflussprinzip, direkt aus den Buchungen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Bilanz',
                        description: 'Für alle, die bilanzieren, gegliedert nach Positionen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Umsatzsteuer-Voranmeldung',
                        description: 'Kennzahlen fertig berechnet, mit Abgabefrist im Blick.'
                    }
                ]
            },
            {
                title: 'Übergabe an den Steuerberater',
                description: 'Damit Kassenprüfung und Steuerberater keine Fragen offen haben.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'DATEV- & CSV-Export',
                        description:
                            'Buchungen im DATEV-Format für die Kanzlei, Auswertungen als CSV für Vorstand, Geschäftsführung und Kassenprüfer.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Journal & Kontenblätter',
                        description: 'Alle Buchungen in zeitlicher Reihenfolge und jedes Konto mit Saldovortrag einzeln einsehbar.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Kostenstellen',
                        description:
                            'Sparten, Kurse oder Projekte einzeln auswerten und sehen, welcher Bereich wirtschaftlich arbeitet.'
                    }
                ]
            },
            {
                title: 'Self-Service für Mitglieder und Kunden',
                description: 'Weniger Rückfragen, mehr Transparenz.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Rechnungsarchiv im Profil',
                        description:
                            'Rechnungen jederzeit selbst herunterladen, zum Beispiel für die Steuererklärung oder die Krankenkasse.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Online-Payment im Portal',
                        description:
                            'Offene Beträge direkt per PayPal, Kreditkarte und weiteren Zahlungsarten begleichen. Die Zahlung wird sofort an der Rechnung vermerkt.'
                    }
                ]
            },
            {
                title: 'FAQ zu Abrechnung und Buchhaltung',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Für wen eignet sich die Lösung?',
                        description:
                            'Für Sportvereine genauso wie für Tennisschulen, Kampfsportschulen, Tanzschulen und andere Sportanbieter. Vereine nutzen häufig SKR 42, Sportschulen SKR 03 oder SKR 04. Beides ist von Anfang an dabei.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Muss ich bilanzieren oder reicht die EÜR?',
                        description:
                            'Das hängt von der Rechtsform und der Größe ab. Gemeinnützige Vereine und viele Sportschulen als Einzelunternehmen ermitteln ihren Gewinn meist per Einnahmen-Überschuss-Rechnung, eine GmbH oder UG bilanziert immer. Sportision bucht intern doppelt und liefert daraus beides. Was für dich gilt, klärst du am besten mit deinem Steuerberater.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Kann mein Steuerberater weiter mit DATEV arbeiten?',
                        description:
                            'Ja. Die Buchungen lassen sich im DATEV-Format exportieren und direkt in die Kanzleisoftware übernehmen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Kann ich während des laufenden Jahres umsteigen?',
                        description:
                            'Ja. Die Anfangsbestände übernimmst du über die Eröffnungsbilanz, offene Rechnungen per Import.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Übermittelt Sportision die Umsatzsteuer-Voranmeldung an das Finanzamt?',
                        description:
                            'Nein. Die Übermittlung läuft weiterhin über ELSTER oder deinen Steuerberater. Sportision berechnet die Kennzahlen und zeigt die Frist, damit du die Werte nur noch übertragen musst.'
                    }
                ]
            }
        ]
    },
    {
        title: 'Mitgliederverwaltung, die deinen Verein spürbar entlastet',
        slug: 'mitgliederverwaltung',
        moduleNameKey: 'clubmembermanagementtool',
        seo: {
            title: 'Mitgliederverwaltung für Sportvereine | Sportision',
            description:
                'Verwalte deine Mitglieder digital: Online-Anträge, Self-Service-Portal & DSGVO-konforme Datenpflege. Mehr Überblick, weniger Aufwand. Jetzt entdecken!',
            keywords: [
                'mitgliederverwaltung',
                'digitale vereinsverwaltung',
                'vereinssoftware',
                'online mitgliedsantrag',
                'arbeitsdienstverwaltung',
                'beitragsabrechnung',
                'newsletter verein',
                'mitglieder dashboard'
            ]
        },
        description:
            'Bring Ordnung in deine Vereinsverwaltung und spare Woche für Woche Zeit. Sportision digitalisiert Mitgliedsanträge, Stammdaten, Arbeitsdienst und Beitragsabrechnung in einem System.',
        image: '/images/modules/club_members.png',
        relatedSlugs: ['rechnungen', 'online-anmeldungen', 'platzbuchungen', 'reiten'],

        functions: [
            {
                name: 'Zentrale Mitgliederverwaltung',
                descriptionShort: 'Alle Mitglieder in einer Datenbank',
                descriptionLong:
                    'Die zentrale Mitgliederverwaltung bündelt alle Personen des Vereins in einer strukturierten Datenbank. Stammdaten wie Adresse, Kontaktdaten und Mitgliedsstatus sind jederzeit abrufbar. Filter- und Suchfunktionen ermöglichen eine schnelle Übersicht über aktive, passive sowie ehemalige Mitglieder und erleichtern die tägliche Vereinsverwaltung erheblich.'
            },
            {
                name: 'Gruppen- und Spartenverwaltung',
                descriptionShort: 'Mitglieder in Gruppen organisieren',
                descriptionLong:
                    'Mitglieder werden Abteilungen und Kategorien zugeordnet, zum Beispiel Mannschaften, Kurse oder Altersklassen. Diese Struktur bildet die Grundlage für gezielte Kommunikation, Beitragslogiken und Auswertungen.'
            },
            {
                name: 'Rollen- und Funktionsverwaltung',
                descriptionShort: 'Ämter und Funktionen pflegen',
                descriptionLong:
                    'Vorstandsämter, Trainerrollen, Kassierer und weitere Funktionen werden am Mitglied hinterlegt und mit passenden Berechtigungen verknüpft. So bleiben Zuständigkeiten klar.'
            },
            {
                name: 'Individuelle Zusatzfelder',
                descriptionShort: 'Eigene Datenfelder definieren',
                descriptionLong:
                    'Mit frei definierbaren Zusatzfeldern können Vereine ihre Mitgliederdaten individuell erweitern wie zum Beispiel um Lizenznummern, Trikotgrößen, Qualifikationen oder vereinsinterne Kennzeichnungen.'
            },
            {
                name: 'Mitgliedshistorie',
                descriptionShort: 'Änderungen nachverfolgen',
                descriptionLong:
                    'Die Mitgliedshistorie dokumentiert alle relevanten Änderungen wie Statuswechsel, Gruppenänderungen, Zahlungen, Notizen und versendete Dokumente. Dadurch bleibt jede Entwicklung nachvollziehbar.'
            },
            {
                name: 'Notizen und Aufgaben',
                descriptionShort: 'Aufgaben bei Mitgliedern hinterlegen',
                descriptionLong:
                    'Notizen und Aufgaben lassen sich direkt bei Mitgliedern hinterlegen. Das erleichtert Rückfragen, Gespräche und die Nachverfolgung im Vereinsalltag.'
            },
            {
                name: 'Jubiläums- und Geburtstagslisten',
                descriptionShort: 'Ehrungen im Blick behalten',
                descriptionLong:
                    'Automatische Auswertungen zu Geburtstagen, Mitgliedsjubiläen und besonderen Anlässen unterstützen eine wertschätzende Vereinskommunikation und erleichtern die Planung von Ehrungen.'
            },
            {
                name: 'Mitgliederstatistiken',
                descriptionShort: 'Entwicklung auswerten',
                descriptionLong:
                    'Statistiken zu Alter, Geschlecht, Sparte sowie Ein- und Austritten liefern wertvolle Einblicke in die Mitgliederentwicklung. Ein Dashboard vergleicht Monatsverläufe und Kategorien mit dem Vorjahr und zeigt eingehende Kündigungen.'
            },
            {
                name: 'Online-Beitrittsformular',
                descriptionShort: 'Digitale Mitgliedsanmeldung',
                descriptionLong:
                    'Interessenten können über ein Online-Beitrittsformular direkt Mitglied werden. Die eingegebenen Daten fließen automatisch in die Mitgliederverwaltung ein und reduzieren den manuellen Erfassungsaufwand.'
            },
            {
                name: 'Aufnahme-Workflows',
                descriptionShort: 'Prüfen und freigeben',
                descriptionLong:
                    'Automatisierte oder halbautomatische Workflows steuern den Aufnahmeprozess von der Prüfung über die Freigabe bis hin zur Begrüßungsmail und Gruppenzuordnung.'
            },
            {
                name: 'Kündigungsverwaltung',
                descriptionShort: 'Austritte sauber abwickeln',
                descriptionLong:
                    'Kündigungen werden mit Eingangsdatum, Grund und Austrittsdatum erfasst. Das Mitglied erhält automatisch eine Bestätigung per E-Mail mit PDF. Wird eine Kündigung zurückgenommen, lässt sie sich mit einem Klick widerrufen.'
            },
            {
                name: 'Schrank- und Spindverwaltung',
                descriptionShort: 'Wer hat welchen Schrank',
                descriptionLong:
                    'Schränke und Spinde werden Mitgliedern zugewiesen, mit Belegungsverlauf und eigenen Berechtigungen. Die Gebühr läuft automatisch in die Beitragsabrechnung, und bei einer Kündigung wird der Schrank mit freigegeben.'
            },
            {
                name: 'Mitgliederkonten per Sammelaktion',
                descriptionShort: 'App-Zugänge für alle auf einmal',
                descriptionLong:
                    'Lege Sportision-Konten für einzelne oder viele Mitglieder gleichzeitig an. Die Zugangsdaten gehen per E-Mail raus, und die Mitglieder können sofort die App nutzen.'
            },
            {
                name: 'CSV-Import mit Duplikatabgleich',
                descriptionShort: 'Bestandsdaten sauber übernehmen',
                descriptionLong:
                    'Beim Import aus Excel oder dem Altsystem legst du selbst fest, an welchen Feldern doppelte Mitglieder erkannt werden. So entstehen keine Dubletten, auch wenn du mehrfach importierst.'
            },
            {
                name: 'Mitgliederportal',
                descriptionShort: 'Selbstbedienung für Mitglieder',
                descriptionLong:
                    'Im Mitgliederportal können Mitglieder ihre Daten selbst pflegen, Dokumente abrufen, Termine einsehen sowie An- oder Abmeldungen vornehmen. Das entlastet die Verwaltung spürbar.'
            },
            {
                name: 'Eltern- und Familienzugänge',
                descriptionShort: 'Familienkonten verwalten',
                descriptionLong:
                    'Familienzugänge ermöglichen es Eltern oder Erziehungsberechtigten, mehrere Kinder zentral zu verwalten inklusive der Datenpflege, Anmeldungen und Kommunikation.'
            },
            {
                name: 'Rollen- und Rechtekonzept',
                descriptionShort: 'Zugriff fein steuern',
                descriptionLong:
                    'Ein differenziertes Rollen- und Rechtekonzept legt pro Bereich fest, wer Daten sehen und bearbeiten darf, vom Vorstand über Trainer bis zur Geschäftsstelle.'
            },
            {
                name: 'Änderungsprotokoll (Audit-Log)',
                descriptionShort: 'Nachvollziehbare Änderungen',
                descriptionLong:
                    'Das Audit-Log dokumentiert transparent, wer wann welche Daten geändert hat. Dies unterstützt den Datenschutz, die interne Kontrolle und rechtssichere Prozesse.'
            },
            {
                name: 'DSGVO-Unterstützung',
                descriptionShort: 'Datenschutz rechtssicher organisieren',
                descriptionLong:
                    'Sportision unterstützt eine DSGVO-konforme Vereinsverwaltung mit Einwilligungen in Formularen, Anonymisierung ausgetretener Mitglieder und einem lückenlosen Änderungsprotokoll.'
            },
            {
                name: 'Sichere Cloud-Infrastruktur',
                descriptionShort: 'Hosting im Rechenzentrum',
                descriptionLong:
                    'Die Software wird in sicheren, zertifizierten Rechenzentren betrieben und bietet Verschlüsselung, Backups sowie Hochverfügbarkeit ganz ohne eigenen Server im Verein.'
            },
            {
                name: 'Abteilungen und Buchungskreise',
                descriptionShort: 'Mehrspartenvereine abbilden',
                descriptionLong:
                    'Abteilungen bilden die Struktur von Mehrspartenvereinen ab. In der Buchhaltung lassen sich zusätzlich getrennte Buchungskreise führen, etwa für den Förderverein.'
            }
        ],
        sections: [
            {
                title: 'Digitale Mitgliederverwaltung, die Vereine wirklich entlastet',
                description:
                    'Mit Sportision wird Mitgliederverwaltung einfach, übersichtlich und zukunftssicher. Statt verstreuter Listen, manueller Prozesse und doppelter Pflege bündelt Sportision alle relevanten Vereinsdaten in einer zentralen, sicheren Plattform. Von der Aufnahme neuer Mitglieder über Rollen und Funktionen bis hin zu Datenschutz, Kommunikation und Auswertungen: alles greift nahtlos ineinander. Vereine, Abteilungen und Verbände behalten jederzeit den Überblick über Mitglieder, Kontakte und Strukturen. Automatisierte Workflows, Self-Service-Funktionen für Mitglieder und ein klares Rollen- und Rechtesystem reduzieren den administrativen Aufwand spürbar und schaffen Raum für das Wesentliche: Vereinsleben, Engagement und Gemeinschaft. Ob kleiner Sportverein oder komplexe Organisation mit mehreren Abteilungen: Sportision passt sich flexibel an eure Anforderungen an. Modern, DSGVO-konform und cloudbasiert unterstützt Sportision eine professionelle Vereinsführung und sorgt dafür, dass Verwaltung wieder leicht fällt.',
                highlight: 'box'
            },

            {
                title: 'Mitgliedsaufnahme & Self-Service',
                description: 'Weniger Verwaltung, mehr Komfort: digitale Prozesse für Mitglieder und Verein.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Online-Beitritt & Workflows',
                        description:
                            'Interessenten können sich über ein Online-Beitrittsformular direkt anmelden. Aufnahme-Workflows steuern die Prüfung, Freigabe und Begrüßung automatisch inklusive der Zuordnung zu Gruppen und Sparten.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Mitgliederportal & Familienzugänge',
                        description:
                            'Im Mitgliederportal pflegen Mitglieder ihre Daten selbst, laden Dokumente herunter und melden sich zu Terminen an oder ab. Familienzugänge ermöglichen Eltern die zentrale Verwaltung mehrerer Kinder, was ideal für Jugend- sowie Breitensportvereine ist.'
                    }
                ]
            },

            {
                title: 'Kündigung & Austritt',
                description: 'Auch beim Abschied alles korrekt und nachvollziehbar.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Kündigungen erfassen',
                        description:
                            'Eingangsdatum, Grund und Austrittsdatum an einer Stelle. Das Mitglied bekommt automatisch eine Bestätigung mit PDF.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Anteilig abrechnen',
                        description:
                            'Endet die Mitgliedschaft unterm Jahr, wird der Beitrag auf Wunsch monatlich oder tagesgenau anteilig berechnet.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Rücknahme mit einem Klick',
                        description:
                            'Überlegt es sich ein Mitglied anders, wird die Kündigung widerrufen. Die Schrankzuweisung zieht automatisch mit.'
                    }
                ]
            },

            {
                title: 'Beiträge & Finanzen',
                description: 'Beiträge, Zahlungen und Buchhaltung digital im Griff, transparent und rechtssicher.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Flexible Beitragsmodelle',
                        description:
                            'Verwalte unterschiedliche Beitragssätze nach Alter, Sparte, Familie oder Förderstatus. Sportision bildet individuelle Beitragslogiken genau so ab, wie dein Verein sie benötigt.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Automatische Beitragsänderungen',
                        description:
                            'Beiträge passen sich automatisch an, sobald Mitglieder Altersgrenzen erreichen oder die Sparte wechseln.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Automatische Abrechnung & SEPA',
                        description:
                            'Erstelle Beitragsabrechnungen automatisch und ziehe Beiträge per SEPA-Lastschrift ein. Die Offene-Posten-Verwaltung und das Mahnwesen sorgen für Übersicht und reduzieren Rückfragen sowie Zahlungsausfälle.'
                    },
                    {
                        type: 'imageCard',
                        image: '/images/modules/club_member_dynamic_category.png'
                    }
                ]
            },

            {
                title: 'Kommunikation im Verein',
                description: 'Alle erreichen, schnell, gezielt und direkt über eine zentrale Plattform.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Serien-E-Mails & Newsletter',
                        description:
                            'Versende personalisierte Rundmails an ausgewählte Mitglieder, mit Platzhaltern und Anhängen. Einheitliche Vorlagen sparen Zeit und sorgen für eine professionelle Kommunikation.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'In-App-Chat & Newsfeed',
                        description:
                            'Chatte direkt mit Teams oder Gruppen und teile Vereinsnews über die Pinnwand. Push-Benachrichtigungen stellen sicher, dass wichtige Informationen sofort ankommen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Eigenes Vereinspostfach',
                        description:
                            'Mails gehen im Namen deines Vereins raus, Antworten landen im gemeinsamen Postfach und erscheinen im Profil des jeweiligen Mitglieds.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Mehr Nähe, weniger Missverständnisse',
                        description:
                            'Klare Kommunikation stärkt das Vereinsleben, erhöht die Beteiligung und reduziert den Abstimmungsaufwand insbesondere bei großen Vereinen.'
                    }
                ]
            },

            {
                title: 'Termine, Events & Ressourcen',
                description: 'Trainings, Veranstaltungen und Helfereinsätze effizient organisieren.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Veranstaltungskalender & Anmeldungen',
                        description:
                            'Plane Trainings, Spiele, Sitzungen und Events zentral. Mitglieder melden sich online an oder ab, während Verantwortliche die Zusagen und Absagen jederzeit im Blick behalten.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Arbeitsdienst & Aufgaben',
                        description:
                            'Verteile Aufgaben und Arbeitsdienste an Mitglieder, auch wiederkehrend, und erfasse die geleisteten Arbeitsstunden direkt im System.'
                    }
                ]
            },

            {
                title: 'Organisation und Struktur',
                description: 'Wissen zentral ablegen und Zusammenarbeit strukturieren.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Dokumente am Mitglied',
                        description:
                            'Hinterlege Dokumente direkt beim Mitglied, beim Event oder bei der Aufgabe, zum Beispiel Anträge oder Nachweise. So ist alles dort, wo es gebraucht wird.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Schrank- & Spindverwaltung',
                        description:
                            'Schränke zuweisen, Belegung nachverfolgen und die Gebühr automatisch mit dem Beitrag abrechnen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Mitgliedsdaten aus allen Modulen',
                        description:
                            'Alle Module greifen auf dieselbe Mitgliederbasis zu. Änderungen in der Mitgliederverwaltung werden automatisch in die Buchhaltung, Kursverwaltung und das Eventmodul übernommen ohne doppelte Pflege.'
                    },
                    {
                        type: 'imageCard',
                        image: '/images/modules/club_member_preview.png'
                    }
                ]
            },

            {
                title: 'Auswertungen & Kontrolle',
                description: 'Daten verstehen, Entscheidungen verbessern und den Verein strategisch steuern.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Statistiken & Reports',
                        description:
                            'Analysiere Mitgliederentwicklung, Finanzen, Teilnahme und Kommunikation. Dashboards sowie Berichte liefern fundierte Entscheidungsgrundlagen für den Vorstand und die Verwaltung.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Exporte für Verbände',
                        description:
                            'Erstelle CSV-Exporte und die Bestandserhebung für den Landessportbund direkt aus den Mitgliedsdaten, ohne doppelte Arbeit.'
                    }
                ]
            },

            {
                title: 'Sicherheit & Service',
                description: 'Rechtssicher, zuverlässig und begleitet, damit dein Verein sorgenfrei arbeitet.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'DSGVO & Rechtekonzept',
                        description:
                            'Sportision unterstützt eine DSGVO-konforme Datenverarbeitung mit Einwilligungen, Anonymisierung, Audit-Logs und fein abgestuften Zugriffsrechten.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Support & Schulungen',
                        description:
                            'Online-Hilfe, Tutorials, persönlicher Support sowie Schulungen und Webinare begleiten euren Verein vom Start bis zum täglichen Einsatz.'
                    }
                ]
            }
        ]
    },
    {
        title: 'Vereinskommunikation mit eigenem Postfach',
        slug: 'vereinskommunikation',
        seo: {
            title: 'Vereinskommunikation & E-Mail-Postfach für Vereine | Sportision',
            description:
                'Mails mit eigener Vereinsadresse, Antworten im gemeinsamen Postfach, Zustellstatus, Push-Nachrichten und Chat in einem System. Jetzt entdecken!',
            keywords: [
                'vereinskommunikation',
                'mitgliederkommunikation verein',
                'e-mail an mitglieder',
                'vereinspostfach',
                'gemeinsames postfach verein',
                'rundmail verein',
                'serienmail verein',
                'push nachrichten verein',
                'vereins app chat',
                'zustellstatus e-mail',
                'smtp verein'
            ]
        },
        description:
            'Alle Nachrichten deines Vereins an einem Ort: Mails gehen im Namen deines Vereins raus, Antworten landen im gemeinsamen Postfach, und du siehst für jede Mail, ob sie angekommen ist. Dazu kommen Push-Nachrichten, Newsfeed und Gruppenchat in der App.',
        image: '/images/modules/club_member_preview.png',
        relatedSlugs: ['mitgliederverwaltung', 'app', 'online-anmeldungen'],

        functions: [
            {
                name: 'Eigene Absenderadresse',
                descriptionShort: 'Mails im Namen deines Vereins',
                descriptionLong:
                    'Jeder Verein bekommt eine eigene Adresse, und Mails an Mitglieder gehen mit dem Vereinsnamen als Absender raus. Kein noreply mehr: Mitglieder sehen sofort, von wem die Nachricht kommt, und können direkt antworten.'
            },
            {
                name: 'Gemeinsames Vereinspostfach',
                descriptionShort: 'Antworten landen an einem Ort',
                descriptionLong:
                    'Antworten auf Rechnungen, Bestätigungen oder Rundmails kommen im Postfach des Vereins an. Alle Verantwortlichen mit Berechtigung sehen dieselben Nachrichten, mit Suche, Ordnern für Ungelesen und Archiv sowie Anhängen.'
            },
            {
                name: 'Antworten mit Zusammenhang',
                descriptionShort: 'Jede Antwort mit ihrer Ursprungsmail',
                descriptionLong:
                    'Zu jeder eingehenden Nachricht siehst du, auf welche Mail sie antwortet und von wann diese war. Deine Antwort schreibst du direkt im Postfach, auf Wunsch mit Zitat, und sie bleibt beim Verlauf gespeichert.'
            },
            {
                name: 'Zuordnung zum Mitglied',
                descriptionShort: 'Nachrichten im Mitgliederprofil',
                descriptionLong:
                    'Antwortet ein Mitglied, wird die Nachricht dem Mitglied zugeordnet. Im Mitgliederprofil findest du den Verlauf, ohne in privaten Postfächern suchen zu müssen.'
            },
            {
                name: 'Lesestatus im Team',
                descriptionShort: 'Wer hat was gelesen',
                descriptionLong:
                    'Das Postfach zeigt, wer eine Nachricht wann gelesen hat. So bleibt keine Mail liegen, nur weil jeder dachte, ein anderer kümmert sich.'
            },
            {
                name: 'Weiterleitung an bestehende Adressen',
                descriptionShort: 'Nichts verpassen',
                descriptionLong:
                    'Eingehende Mails können zusätzlich an eine bestehende Adresse weitergeleitet werden, zum Beispiel an die Geschäftsstelle. Auch nach einer Umbenennung empfangen frühere Adressen weiter Antworten.'
            },
            {
                name: 'Zustellstatus für jede Mail',
                descriptionShort: 'Angekommen oder nicht',
                descriptionLong:
                    'Für jede versendete Mail siehst du den Status direkt vom Mailanbieter: zugestellt, zurückgewiesen, geöffnet. Bei Rückfragen wie „Ich habe keine Rechnung bekommen“ hast du sofort die Antwort.'
            },
            {
                name: 'Schutz der Zustellbarkeit',
                descriptionShort: 'Damit Mails nicht im Spam landen',
                descriptionLong:
                    'Sportision überwacht die Versandqualität. Steigen Rückläufer oder Beschwerden kritisch an, wird der Massenversand pausiert, während wichtige Mails wie Bestätigungen und Rechnungen weiter ankommen.'
            },
            {
                name: 'Eigener Mailserver möglich',
                descriptionShort: 'SMTP mit eigener Domain',
                descriptionLong:
                    'Wer lieber über den eigenen Mailserver verschickt, hinterlegt die SMTP-Zugangsdaten und prüft sie mit einem Klick. Ein Versandlimit pro Minute sorgt dafür, dass auch große Rundmails beim Anbieter nicht hängen bleiben.'
            },
            {
                name: 'Rundmails mit Vorlagen',
                descriptionShort: 'Eine Nachricht, viele Empfänger',
                descriptionLong:
                    'Schreibe Rundmails an ausgewählte Mitglieder, mit Platzhaltern für persönliche Daten, Anhängen und wiederverwendbaren Vorlagen.'
            },
            {
                name: 'Push-Nachrichten & Newsfeed',
                descriptionShort: 'Direkt aufs Handy',
                descriptionLong:
                    'Wichtige Neuigkeiten erreichen Mitglieder als Push-Nachricht in der Sportision App. Im Newsfeed bleiben Beiträge sichtbar, auch für alle, die die Nachricht verpasst haben.'
            },
            {
                name: 'Gruppenchat in der App',
                descriptionShort: 'Kommunikation in Trainingsgruppen',
                descriptionLong:
                    'Trainer und Teilnehmer tauschen sich direkt in der App aus, statt in privaten Messenger-Gruppen. Kurzfristige Änderungen erreichen alle, die es betrifft.'
            }
        ],
        sections: [
            {
                title: 'Schluss mit noreply und verlorenen Antworten',
                highlight: 'box',
                description:
                    'Rechnungen, Bestätigungen und Rundmails verschickt fast jedes Vereinsprogramm. Was danach passiert, bleibt meist offen: Antworten gehen an eine noreply-Adresse oder landen im privaten Postfach eines Vorstandsmitglieds. Mit Sportision schreibt dein Verein unter eigenem Namen, Antworten kommen im gemeinsamen Vereinspostfach an und werden dem richtigen Mitglied zugeordnet. Du siehst, ob jede Mail zugestellt wurde, und das Team sieht, wer eine Nachricht schon gelesen hat.'
            },
            {
                title: 'Eigene Adresse & Postfach',
                description: 'Ein Absender, ein Posteingang, ein Team.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Eigene Absenderadresse',
                        description:
                            'Mails gehen mit dem Namen deines Vereins raus. Mitglieder erkennen den Absender und können direkt antworten.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Gemeinsames Vereinspostfach',
                        description:
                            'Alle Antworten an einem Ort, mit Suche, Ungelesen-Ordner, Archiv und Anhängen. Für alle im Team mit Berechtigung.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Antworten mit Zusammenhang',
                        description:
                            'Jede eingehende Nachricht zeigt, auf welche Mail sie antwortet. Geantwortet wird direkt aus dem Postfach.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Zuordnung zum Mitglied',
                        description: 'Nachrichten von Mitgliedern findest du auch im jeweiligen Mitgliederprofil.'
                    }
                ]
            },
            {
                title: 'Zuverlässig zugestellt',
                description: 'Wissen statt hoffen, dass die Mail angekommen ist.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Zustellstatus',
                        description:
                            'Für jede Mail siehst du, ob sie zugestellt, zurückgewiesen oder geöffnet wurde, direkt vom Mailanbieter.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Schutz der Zustellbarkeit',
                        description:
                            'Bei kritischer Versandqualität wird der Massenversand pausiert. Bestätigungen und Rechnungen kommen trotzdem an.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Eigener Mailserver',
                        description:
                            'Alternativ verschickst du über deinen eigenen SMTP-Server, mit Verbindungstest und Versandlimit pro Minute.'
                    }
                ]
            },
            {
                title: 'Alle Kanäle in einem System',
                description: 'E-Mail, App und Chat greifen ineinander.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Rundmails mit Vorlagen',
                        description: 'Nachrichten an ausgewählte Mitglieder, mit Platzhaltern, Anhängen und Vorlagen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Push-Nachrichten & Newsfeed',
                        description: 'Neuigkeiten direkt aufs Handy und dauerhaft im Newsfeed der App.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Gruppenchat',
                        description: 'Trainer und Gruppen kommunizieren in der App statt in privaten Messengern.'
                    }
                ]
            },
            {
                title: 'FAQ zur Vereinskommunikation',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Welchen Absender sehen meine Mitglieder?',
                        description:
                            'Mitglieder sehen den Namen deines Vereins mit dem Zusatz „über Sportision“ und eine eigene Adresse für deinen Verein. Den Absendernamen legst du selbst fest.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Was passiert mit Antworten auf Rechnungen und Bestätigungen?',
                        description:
                            'Sie landen im Vereinspostfach unter Nachrichten und auf Wunsch zusätzlich bei einer Adresse deiner Wahl.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Muss ich meine bestehende E-Mail-Adresse aufgeben?',
                        description:
                            'Nein. Deine bisherige Adresse bleibt, wie sie ist. Du kannst eingehende Antworten zusätzlich dorthin weiterleiten lassen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Kann ich weiter meinen eigenen Mailserver nutzen?',
                        description:
                            'Ja. Dann gehen die Mails über deinen SMTP-Server mit deiner eigenen Adresse raus. Zustellstatus und Antworten im Vereinspostfach gibt es in diesem Fall nicht, weil die Mails nicht über Sportision laufen.'
                    }
                ]
            }
        ]
    },
    {
        title: 'Online Anmeldungen',
        slug: 'online-anmeldungen',
        moduleNameKey: 'eventtool',
        description:
            'Ob Trainingscamp, Turnier oder Vereins Event, mit Sportision erstellst du Online Anmeldungen in Minuten statt Tagen.',
        seo: {
            title: 'Online-Anmeldungen für Sportvereine | Sportision',
            description:
                'Digitalisiere deine Anmeldungen: Kurse, Turniere & Wartelisten zentral verwalten. Inklusive Online-Zahlung für weniger Papierkram. Jetzt entdecken!',
            keywords: [
                'online anmeldungen sportverein',
                'online buchungssystem schule',
                'kursbuchung sportverein',
                'online kursanmeldung',
                'anmeldeplattform sportverein',
                'teilnehmerverwaltung',
                'digitale anmeldung',
                'sportkurse online buchen',
                'vereinssoftware',
                'online anmeldesystem'
            ]
        },
        image: '/images/modules/event_list.png',
        relatedSlugs: ['trainingsplanerstellung', 'mitgliederverwaltung', 'rechnungen'],

        functions: [
            {
                name: 'Maßgeschneiderte Formulare',
                descriptionShort: 'Individuelle Anmeldeformulare und Abfragen',
                descriptionLong:
                    'Erstelle flexible Anmeldeformulare mit individuell anpassbaren Feldern. Sammle genau die Informationen, die du für deine Kurse, Trainings oder Events benötigst, von Kontaktdaten über medizinische Hinweise bis hin zu speziellen Teilnehmerwünschen.'
            },
            {
                name: 'Automatisierte Warteliste',
                descriptionShort: 'Automatisches Nachrück-Verfahren',
                descriptionLong:
                    'Ist ein Kurs oder Termin ausgebucht, können sich Interessenten auf eine Warteliste eintragen. Wird ein Platz frei, rücken Wartende automatisch nach oder erhalten gleichzeitig eine Benachrichtigung nach dem Prinzip „First come, first served“, um freie Plätze optimal zu nutzen.'
            },
            {
                name: 'Serien- & Blockbuchungen',
                descriptionShort: 'Buchung wiederkehrender Termine',
                descriptionLong:
                    'Wiederkehrende Termine wie wöchentliche Trainings, Kurse oder komplette Semester lassen sich in einem Schritt buchen. Das sorgt für Planungssicherheit bei Vereinen, Sportschulen und festen Trainingsgruppen.'
            },
            {
                name: 'Regelbasierte Buchungsrechte',
                descriptionShort: 'Einschränkung nach Mitgliedsstatus',
                descriptionLong:
                    'Buchungsrechte lassen sich flexibel definieren wie zum Beispiel nach Mitgliedsstatus, Uhrzeit oder Vorlauf. So können Primetimes exklusiv für Mitglieder reserviert und Gastbuchungen gezielt eingeschränkt werden.'
            },
            {
                name: 'Online-Payment & SEPA',
                descriptionShort: 'Automatisierte Zahlungsabwicklung',
                descriptionLong:
                    'Das System integriert moderne Online-Zahlungen wie PayPal, Kreditkarte oder Apple Pay sowie die automatische Erstellung von SEPA-Lastschriftdateien für Mitgliedsbeiträge und wiederkehrende Zahlungen.'
            },
            {
                name: 'Gutscheine, Guthaben- & Punktekarten',
                descriptionShort: 'Prepaid-Systeme für Mitglieder',
                descriptionLong:
                    'Mitglieder können Gutscheine kaufen, Guthaben aufladen oder Punktekarten wie 10er-Karten erwerben. Bei jeder Buchung wird der entsprechende Betrag automatisch abgezogen.'
            },
            {
                name: 'Preise nach Teilnehmergruppe',
                descriptionShort: 'Mitglieder zahlen anders als Gäste',
                descriptionLong:
                    'Lege für Mitglieder, Nichtmitglieder oder einzelne Kategorien unterschiedliche Preise fest. Bei der Anmeldung gilt automatisch der passende Preis.'
            },
            {
                name: 'Storno-Management',
                descriptionShort: 'Selbstverwaltung von Absagen',
                descriptionLong:
                    'Mitglieder können Buchungen selbst stornieren. Das System prüft automatisch die hinterlegten Fristen und erstattet Guthaben oder berechnet Stornogebühren gemäß den Vereinsregeln.'
            },
            {
                name: 'Buchhaltungsexport',
                descriptionShort: 'Datenübergabe an Steuerberater',
                descriptionLong:
                    'Alle Buchungs- und Zahlungsdaten lassen sich in gängigen Formaten wie CSV oder DATEV exportieren. Das erleichtert die Weiterverarbeitung in der Buchhaltung und reduziert den manuellen Aufwand.'
            },
            {
                name: 'Kiosk-Modus',
                descriptionShort: 'Buchung vor Ort',
                descriptionLong:
                    'Ein Terminal im Vereinsheim ermöglicht spontane Buchungen oder Check-ins vor Ort, was ideal für offene Sportanlagen und den Hallenbetrieb ohne dauerhaftes Personal ist.'
            },
            {
                name: 'Newsletter & Push-Nachrichten',
                descriptionShort: 'Direkte Mitgliederansprache',
                descriptionLong:
                    'E-Mails und Push-Benachrichtigungen informieren Mitglieder über Kursstarts, Änderungen oder Aktionen. Informationen kommen schnell sowie zuverlässig an.'
            },
            {
                name: 'Familien-Accounts',
                descriptionShort: 'Verwaltung von Angehörigen',
                descriptionLong:
                    'Ein Hauptaccount verwaltet mehrere Unterprofile wie zum Beispiel für Kinder. Buchungen, Zahlungen und Kommunikation laufen zentral, was ideal für Familien sowie Kindersportschulen ist.'
            },
            {
                name: 'Buchungsanfragen mit Freigabe',
                descriptionShort: 'Erst prüfen, dann bestätigen',
                descriptionLong:
                    'Für Angebote mit begrenzten Plätzen oder Voraussetzungen nimmst du Anfragen statt fester Buchungen entgegen. Jede Anfrage nimmst du im Web oder in der App an oder lehnst sie ab, und die Teilnehmer werden automatisch informiert.'
            },
            {
                name: 'Papieranmeldungen per KI importieren',
                descriptionShort: 'Foto oder PDF statt Abtippen',
                descriptionLong:
                    'Anmeldungen auf Papier, als PDF oder Foto liest die KI aus. In einer Prüftabelle korrigierst du, was nötig ist, und legst danach alle Buchungen gesammelt an.'
            }
        ],
        sections: [
            {
                title: 'Online buchen, einfach anmelden, alles im Griff',
                description: [
                    'Mit Sportision wird die Online-Buchung von Plätzen, Kursen und Trainings so einfach wie nie zuvor. Ob für Sportvereine, Schulen oder Bildungseinrichtungen: die Online-Anmeldeplattform macht den Unterschied. Mitglieder, Gäste, Schüler und Eltern sehen auf einen Blick, welche Kurse und Trainings verfügbar sind, melden sich über ein einfaches Online-Anmeldeformular an und bezahlen direkt, schnell, transparent und ohne Umwege.',
                    'Statt mühsamer Telefonlisten, fehleranfälliger Excel-Tabellen oder aufwändiger manueller Koordination läuft der gesamte Buchungsprozess digital und automatisiert. Mit Sportision erhältst du ein echtes Buchungssystem für Sportvereine, das auch Schulen-AGs und Ferienprogramme perfekt verwaltet. Ob Einzelbuchung, Serien- oder Kursanmeldung: deine Kursverwaltung online wird zur Routine.',
                    'Die Anmeldeplattform sorgt für klare Belegungspläne, faire Buchungsregeln und optimale Auslastung. Logikbasierte Wartelisten, flexible Preisgestaltung und automatische Storno-Regeln reduzieren Leerstände und entlasten die Verwaltung spürbar. Die Teilnehmerverwaltung läuft vollautomatisch: Alle Anmeldungen werden zentral erfasst, Teilnehmerlisten sind immer aktuell und übersichtlich. Gleichzeitig behalten Betreiber, Vereine und Schulen jederzeit den vollständigen Überblick über Buchungen, Zahlungen und Auslastung.',
                    'Dank integrierter Online-Zahlung, Smart-Facility-Automatisierung und direkter Kommunikation wird aus der Online-Anmeldung ein nahtloses Erlebnis, für Mitglieder, Eltern, Trainer und Organisation gleichermaßen. Mit einer datenschutzkonformen digitalen Anmeldung nach DSGVO vertrauen Vereine und Schulen auf Sicherheit. Modern, effizient und bereit für die Anforderungen heutiger Sportanlagen, Vereine und Schulen.'
                ],
                highlight: 'box'
            },
            {
                title: 'Kontrolliert Buchungen empfangen',
                description: 'Einfach anmelden, schnell buchen und jederzeit den Überblick behalten.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Regelbasierte Buchungsrechte',
                        description:
                            'Lege genau fest, wer wann buchen darf wie zum Beispiel die Primetime nur für Mitglieder, Gäste nur zu Randzeiten oder Buchungen erst kurz vor dem Termin. Dies geschieht fair, transparent und vollständig automatisiert.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Serien- & Blockbuchungen',
                        description:
                            'Wiederkehrende Termine lassen sich in einem Schritt buchen wie wöchentliche Trainings, Kurse oder komplette Semester. Das sorgt für Planungssicherheit bei Vereinen, Sportschulen und festen Teams.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Logikbasierte Wartelisten',
                        description:
                            'Ist ein Kurs ausgebucht, rücken Teilnehmer automatisch nach oder erhalten gleichzeitig eine Benachrichtigung. So bleiben Kurse voll und freie Plätze werden optimal genutzt.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Maßgeschneiderte Formulare',
                        description:
                            'Erstelle flexible Anmeldeformulare mit individuell anpassbaren Feldern. Sammle genau die Informationen, die du für deine Kurse, Trainings oder Events benötigst von den Kontaktdaten über medizinische Hinweise bis hin zu speziellen Teilnehmerwünschen.'
                    },
                    {
                        type: 'imageCard',
                        image: '/images/modules/booking_page.png'
                    }
                ]
            },
            {
                title: 'Anfragen & Papieranmeldungen',
                description: 'Volle Kontrolle über die Teilnehmer und kein Abtippen mehr.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Buchungsanfragen mit Freigabe',
                        description:
                            'Teilnehmer stellen eine Anfrage, du entscheidest im Web oder in der App. Zu- und Absagen gehen automatisch raus.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Papieranmeldungen per KI importieren',
                        description:
                            'Anmeldebögen als Foto oder PDF hochladen. Die KI liest sie aus, du prüfst in einer Tabelle und legst alle Buchungen auf einmal an.'
                    }
                ]
            },
            {
                title: 'Zahlung & Verträge',
                description: 'Digitale Zahlungen, flexible Preise und papierlose Prozesse.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Online-Payment & SEPA',
                        description:
                            'Integrierte Online-Zahlungen per PayPal, Kreditkarte oder Apple Pay sowie automatische SEPA-Lastschriften sorgen für reibungslose Zahlungsprozesse für Mitglieder, Gäste und Kursteilnehmer.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Gutscheine, Guthaben-, Punkt- & 10er-Karten',
                        description:
                            'Mitglieder können Gutscheine kaufen, Guthaben aufladen oder Punktekarten wie 10er-Karten erwerben. Bei jeder Buchung wird der entsprechende Betrag automatisch abgezogen.'
                    }
                ]
            },
            {
                title: 'Kommunikation & Marketing',
                description: 'Mehr Reichweite, bessere Auslastung und direkte Ansprache.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Newsletter & Push-Nachrichten',
                        description:
                            'Informiere Mitglieder direkt über Kursstarts, Änderungen oder Sonderaktionen. Push-Nachrichten und E-Mails sorgen dafür, dass Informationen sofort ankommen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Suche',
                        description:
                            'Mit der integrierten Suchmaschine finden Mitglieder und Interessenten schnell passende Kurse, Trainings oder Events für mehr Buchungen sowie eine bessere Auslastung.'
                    },
                    {
                        type: 'imageCard',
                        image: '/images/modules/bookings.png'
                    }
                ]
            }
        ]
    },
    {
        title: 'Das digitale Trainingsjournal',
        slug: 'trainingsjournal',
        moduleNameKey: 'attendancelisttool',
        seo: {
            title: 'Digitales Trainingsjournal für Vereine | Sportision',
            description:
                'Dokumentiere dein Training mobil: Anwesenheitslisten, Trainingsnotizen & automatische Abrechnung für Trainer. Spare wertvolle Zeit. Jetzt entdecken!',
            keywords: [
                'trainingsjournal',
                'anwesenheitsliste',
                'anwesenheitserfassung',
                'trainer app',
                'teilnehmerverwaltung',
                'digitale anwesenheit',
                'trainingsjournal sportverein',
                'vertretungsmanagement',
                'mobile trainer app',
                'anwesenheitskontrolle',
                'trainingsdokumentation',
                'abrechnung automatisch',
                'dsgvo anwesenheitsliste',
                'teilnehmerstatistik',
                'schüler anwesenheit'
            ]
        },
        description:
            'Digitales Trainingsjournal für Trainer: Trainingseinheiten, Anwesenheitsliste, Notizen, mobile Nutzung und Verwaltung mehrerer Vereine.',
        image: '/images/modules/journal.png',
        relatedSlugs: ['trainingsplanerstellung', 'trainerstunden', 'mitgliederverwaltung'],
        functions: [
            {
                name: 'Management von mehreren Vereinen und Schulen',
                descriptionShort: 'Mehrere Vereine und Schulen verwalten und schnell wechseln, ohne neue Logins.',
                descriptionLong:
                    'Wenn du in mehreren Clubs oder Schulen tätig bist, wechselst du einfach im Account. So hast du alle Trainingspläne im Zugriff und arbeitest effizient ohne Tool Wechsel.'
            },
            {
                name: 'Detaillierte Trainingsdaten',
                descriptionShort: 'Datum, Uhrzeit, Dauer und Teilnehmer, alles sauber an einem Ort.',
                descriptionLong:
                    'Sieh sofort, wer in welcher Gruppe trainiert und ob es Hinweise gibt. Das reduziert Fehler, erleichtert Vorbereitung und macht die Durchführung entspannter.'
            },
            {
                name: 'Einfache Bearbeitung',
                descriptionShort: 'Änderungen und Notizen direkt im Training erfassen.',
                descriptionLong:
                    'Passe Einträge kurzfristig an und halte Notizen fest, wenn sie entstehen. So bleibt die Dokumentation aktuell und du musst später nichts nachtragen.'
            },
            {
                name: 'Eigenverwaltung von Schülern',
                descriptionShort: 'Krankmeldungen und Abwesenheiten selbst eintragen lassen.',
                descriptionLong:
                    'Gib deinen Schülern die Möglichkeit, sich selbst abzumelden. Das spart dir Zeit und sorgt für aktuelle Anwesenheitslisten ohne Rückfragen.'
            },
            {
                name: 'Offene Stunden verteilen',
                descriptionShort: 'Stunden ohne Trainer einfach neu vergeben.',
                descriptionLong:
                    'Freie Stunden können schnell an verfügbare Trainer vergeben werden. So bleibt der Trainingsplan flexibel und du findest immer eine Lösung.'
            },
            {
                name: 'Vertretungsmanagement',
                descriptionShort: 'Vertretungen einfach organisieren und kommunizieren.',
                descriptionLong:
                    'Wenn du eine Vertretung brauchst, kannst du das direkt im System organisieren. Trainer sehen sofort, welche Stunden sie übernehmen oder abgeben können.'
            },
            {
                name: 'Persönlicher Trainer-Stundenplan',
                descriptionShort: 'Alle Trainingsstunden in der App',
                descriptionLong:
                    'Jeder Trainer sieht seine geplanten Trainingsstunden direkt in der persönlichen Sportision-App. Der individuelle Stundenplan ist jederzeit aktuell verfügbar und bildet die Grundlage für Anwesenheit, Trainingsdokumentation und Abrechnung.'
            },
            {
                name: 'Wochenansicht mit Komfortfunktionen',
                descriptionShort: 'Training einfach verwalten',
                descriptionLong:
                    'Eine übersichtliche Wochenansicht ermöglicht es Trainern, Trainings schnell zu überblicken und direkt Aktionen wie zum Beispiel das Absagen, Verschieben oder Bearbeiten von Terminen auszuführen. Zusätzlich können Gruppenchats direkt aus dem Training geöffnet werden.'
            },
            {
                name: 'Digitale Anwesenheitsverfolgung',
                descriptionShort: 'Teilnahme pro Einheit erfassen',
                descriptionLong:
                    'Trainer erfassen Anwesenheiten direkt während oder nach dem Training in der App. Die Anwesenheitsdaten stehen sofort zentral zur Verfügung und bilden eine verlässliche Grundlage für Auswertungen, Nachweise sowie Abrechnungen.'
            },
            {
                name: 'Trainingsnotizen & Inhalte',
                descriptionShort: 'Training dokumentieren',
                descriptionLong:
                    'Im Trainingsjournal können Trainer festhalten, welche Übungen, Inhalte oder Schwerpunkte durchgeführt wurden. So entsteht ein digitales Trainingstagebuch, das Qualität, Entwicklung und Verlauf der Trainings nachvollziehbar dokumentiert.'
            },
            {
                name: 'Zugriff auf Schülerdaten',
                descriptionShort: 'Relevante Infos im Training',
                descriptionLong:
                    'Trainer können auf ausgewählte Schülerdaten aus den Online-Anmeldungen zugreifen wie zum Beispiel Alter, Spielstärke oder Hinweise. Dadurch wird das Training individueller vorbereitet und professionell begleitet.'
            },
            {
                name: 'Schülerstatistiken',
                descriptionShort: 'Anwesenheit & Teilnahme auswerten',
                descriptionLong:
                    'Aus den erfassten Trainingsdaten entstehen Schülerstatistiken wie Anwesenheitsquoten, Teilnahmeverläufe oder Trainingshäufigkeiten. Diese Auswertungen unterstützen die Planung, das Feedback und das Qualitätsmanagement.'
            },
            {
                name: 'Trainerstatistiken',
                descriptionShort: 'Geleistete Stunden im Überblick',
                descriptionLong:
                    'Sportision wertet aus, wie viele Trainingsstunden ein Trainer gegeben hat und wie hoch die Auslastung war. Die Statistiken schaffen Transparenz und bilden eine saubere Grundlage für die Abrechnung und Organisation.'
            },
            {
                name: 'Automatische Abrechnung',
                descriptionShort: 'Abrechnung aus Trainingsdaten',
                descriptionLong:
                    'Auf Basis der erfassten Anwesenheiten, Trainingsstunden und hinterlegten Preismatrizen erstellt Sportision automatisch Abrechnungen. Honorare oder interne Verrechnungen werden korrekt und ohne manuelle Excel-Logik generiert.'
            },
            {
                name: 'Gruppenchat in der App',
                descriptionShort: 'Direkte Kommunikation im Training',
                descriptionLong:
                    'In der Sportision-App steht ein integrierter Gruppenchat zur Verfügung. Trainer können direkt aus dem Trainingsjournal oder der Wochenansicht mit ihren Gruppen kommunizieren und Informationen schnell teilen.'
            },
            {
                name: 'Zentrale Trainingsdokumentation',
                descriptionShort: 'Alles an einem Ort',
                descriptionLong:
                    'Trainingsjournal, Anwesenheit, Notizen, Kommunikation und Abrechnung greifen in Sportision nahtlos ineinander. Das System ersetzt Zettelwirtschaft sowie Einzeltools durch eine zentrale, digitale Trainingsverwaltung.'
            },
            {
                name: 'Übernahme aus der Trainingsplanung',
                descriptionShort: 'Plan steht, Journal ist fertig',
                descriptionLong:
                    'Gruppen aus der Trainingsplanung landen automatisch im Trainingsjournal, mit Platz, Trainer und Teilnehmern. Änderungen am Plan werden übernommen.'
            },
            {
                name: 'Erinnerungen für Trainer',
                descriptionShort: 'Kein Training bleibt undokumentiert',
                descriptionLong:
                    'Hat ein Trainer ein Training noch nicht eingetragen, erinnert Sportision ihn automatisch, wahlweise am Abend oder am nächsten Morgen. Offene Trainings zur Übernahme werden allen Trainern gesammelt gemeldet.'
            },
            {
                name: 'Trainingsarten mit Pflichtangabe',
                descriptionShort: 'Saubere Daten für die Abrechnung',
                descriptionLong:
                    'Lege fest, dass beim Eintragen der Anwesenheit eine Trainingsart gewählt werden muss. Jede Trainingsart kann ihre eigene Abrechnungsvorlage haben.'
            },
            {
                name: 'Eigene Wiederholungsintervalle',
                descriptionShort: 'Nicht nur wöchentlich',
                descriptionLong:
                    'Trainings wiederholen sich wöchentlich, alle zwei Wochen oder in einem eigenen Rhythmus, auch über die Zeitumstellung hinweg korrekt.'
            },
            {
                name: 'Import aus Online-Anmeldungen',
                descriptionShort: 'Anmeldungen per Vorlage übernehmen',
                descriptionLong:
                    'Anmeldungen aus Online-Formularen übernimmst du per Importvorlage ins Trainingsjournal, inklusive der angegebenen Zeiten, auch wenn sie im Formular auf mehrere Tabellen verteilt sind.'
            }
        ],
        sections: [
            {
                title: 'Das Trainingsjournal, mobil und organisiert',
                description: [
                    'Die Anwesenheitserfassung im organisierten Sport erfordert mehr als Papier und Listen. Du brauchst ein System, das Daten zentral verwaltet, automatisch auswertet und Trainern Arbeit spart. Mit Sportision erhältst du ein professionelles Trainingsjournal, speziell für Sportvereine, Tennisschulen und Schulen. Die mobile Trainer App ermöglicht Anwesenheit in Sekunden zu erfassen, direkt vor Ort. Die Teilnehmerverwaltung läuft zentral und DSGVO-konform. Das digitale Trainingsjournal dokumentiert Trainings-Inhalte automatisch. Die automatische Abrechnung berechnet Trainer-Honorare aus Trainingsdaten. Das Vertretungsmanagement ist flexibel und transparent.',
                    'Die digitale Anwesenheitsliste von Sportision wird zur strategischen Lösung: Deine Trainer arbeiten mobil und effizient. Deine Teilnehmerverwaltung ist zentral und transparent. Deine Abrechnungen sind automatisiert. Egal ob Anwesenheitserfassung für Sportvereine, Tennisschulen oder Schulen: teste jetzt kostenfrei, wie das Trainingsjournal deinen Sportbetrieb revolutioniert.'
                ],
                highlight: 'box'
            },
            {
                title: 'Trainerbereich',
                description: 'Dein Werkzeugkasten für den Platz.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Stunden im Blick',
                        description: 'Durch den Tagesfocus findest du schnell die richtigen Einheiten.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Anwesenheits Tracking',
                        description: 'Erfasse mit wenigen Klicks, wer beim Training da war.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Vereins Wechsel',
                        description: 'Dies ist ideal für Trainer, die in mehreren Clubs tätig sind.'
                    },

                    {
                        type: 'sectionCard',
                        title: 'Mobile Nutzung',
                        description: 'Einfach bedienbar auf dem Smartphone sowie Tablet direkt auf dem Platz.'
                    }
                ]
            },
            {
                title: 'Schülerbereich',
                description: 'Immer up to date.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Trainingszeiten immer im Blick',
                        description: 'Mit dem persönlichen Stundenplan verpasst du keine Einheit mehr.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Selbstverwaltung',
                        description: 'Verwalte deine Daten und Einstellungen eigenständig sowie unkompliziert.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Krankmeldungen',
                        description: 'Melde dich einfach krank und informiere deinen Trainer.'
                    },

                    {
                        type: 'sectionCard',
                        title: 'Chat & Kommunikation',
                        description: 'Bleibe in Kontakt mit deinem Trainer und deiner Gruppe.'
                    }
                ]
            },
            {
                title: 'Übersichtliche Organisation',
                description: 'Spare Zeit bei der Verwaltung und bleib beim Sport.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Effizienz',
                        description:
                            'Dies sorgt für weniger Nacharbeit und mehr Fokus auf das Training sowie die Betreuung deiner Sportler.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Visuelle Indikatoren',
                        description: 'Erkenne Ausfälle oder Hinweise sofort in der Übersicht.'
                    }
                ]
            },
            {
                title: 'Auswertungen & Transparenz',
                description: 'Aus Trainingsdaten werden wertvolle Erkenntnisse.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Schülerstatistiken',
                        description:
                            'Anwesenheitsquoten, Teilnahmeverläufe und Trainingshäufigkeiten lassen sich übersichtlich auswerten. So behalten Sportschulen und Vereine den Überblick über das Engagement sowie die Entwicklung.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Trainerstatistiken',
                        description:
                            'Aus den dokumentierten Einheiten entstehen Statistiken zu geleisteten Stunden, der Auslastung und dem Umfang der Trainertätigkeit, was transparent und nachvollziehbar ist.'
                    }
                ]
            },

            {
                title: 'Automatische Abrechnung',
                description: 'Von der Trainingseinheit direkt zur Abrechnung, ohne Excel.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Abrechnung aus Stunden & Preismatrizen',
                        description:
                            'Basierend auf den erfassten Trainingsstunden und hinterlegten Preismatrizen erstellt Sportision automatisch Abrechnungen. Honorare, interne Verrechnungen oder Kursabrechnungen entstehen korrekt und zeitsparend.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Weniger Aufwand für Verwaltung',
                        description:
                            'Die Kombination aus Trainingsjournal und Abrechnung reduziert die manuelle Nacharbeit erheblich und sorgt für saubere sowie nachvollziehbare Finanzprozesse.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Abrechnungsvorlagen pro Trainingsart',
                        description:
                            'Jede Trainingsart rechnet mit ihrer eigenen Vorlage ab. Ist die Trainingsart Pflicht, fehlt bei der Abrechnung keine Angabe.'
                    }
                ]
            },

            {
                title: 'Vollständig ohne Nachfragen',
                description: 'Das Journal füllt sich fast von selbst.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Übernahme aus der Trainingsplanung',
                        description:
                            'Gruppen, Plätze und Teilnehmer kommen automatisch aus dem Trainingsplan. Änderungen werden übernommen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Erinnerungen für Trainer',
                        description:
                            'Wer ein Training noch nicht eingetragen hat, wird am Abend oder am nächsten Morgen automatisch erinnert.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Eigene Wiederholungsintervalle',
                        description: 'Wöchentlich, alle zwei Wochen oder im eigenen Rhythmus, auch über die Zeitumstellung hinweg.'
                    }
                ]
            },

            {
                title: 'Kommunikation direkt im Trainingsalltag',
                description: 'Kurze Wege zwischen Trainern, Gruppen und Organisation.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Gruppenchat in der App',
                        description:
                            'Trainer und Teilnehmer kommunizieren direkt über den integrierten Gruppenchat. Änderungen, Hinweise oder Rückfragen lassen sich schnell klären ohne externe Messenger.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Alles an einem Ort',
                        description:
                            'Planung, Dokumentation, Kommunikation und Abrechnung greifen in Sportision nahtlos ineinander für einen strukturierten sowie modernen Trainingsbetrieb.'
                    }
                ]
            }
        ]
    },
    {
        title: 'Automatische Trainingsplan-Erstellung',
        slug: 'trainingsplanerstellung',
        moduleNameKey: 'trainingplantool',
        description:
            'Planung neu gedacht. Übernimm Anmeldungen samt Wunschzeiten und Wunschpartnern, lass dir Gruppen automatisch vorschlagen und plane Trainer und Plätze per Drag & Drop. Der Plan-Check zeigt, was noch offen ist, bevor die Trainingszeiten rausgehen.',
        seo: {
            title: 'Digitale Trainingsplanung für Vereine | Sportision',
            description:
                'Trainingsplanung für Vereine & Tennisschulen: automatische Gruppeneinteilung mit Wunschzeiten und Wunschpartnern, Drag & Drop und Abrechnung. Jetzt entdecken!',
            keywords: [
                'trainingsplan erstellen',
                'trainingsplanerstellung',
                'trainingsplanung sportverein',
                'trainingskalender sportverein',
                'drag und drop trainingsplaner',
                'gruppeneinteilung',
                'gruppeneinteilung automatisch',
                'trainer management',
                'kapazitätsplanung',
                'hallenplanung verein',
                'wintertraining planung',
                'trainingsplan software tennisschule',
                'teilnehmerverwaltung training',
                'digitale trainingsplanung',
                'trainingsplan verein'
            ]
        },
        image: '/images/modules/trainingsplan.png',
        relatedSlugs: ['online-anmeldungen', 'trainingsjournal', 'trainerstunden'],

        functions: [
            {
                name: 'Import aus Online-Anmeldungen',
                descriptionShort: 'Anmeldungen samt Wünschen übernehmen',
                descriptionLong:
                    'Anmeldungen übernimmst du mit dem Import-Assistenten direkt aus den Online-Anmeldungen, inklusive Wunschzeiten, gewünschter Gruppengröße und Wunschpartnern. Felder ordnest du einmal zu, eine Vorschau zeigt das Ergebnis vor der Übernahme.'
            },
            {
                name: 'Automatische Gruppenvorschläge',
                descriptionShort: 'Gruppen auf Knopfdruck',
                descriptionLong:
                    'Sportision berechnet Gruppenvorschläge aus Alter, Gruppengröße, Wunschzeiten, Wunschpartnern und verfügbaren Plätzen. Wie stark jedes Kriterium zählt, stellst du selbst ein. Wer in keine Gruppe passt, wird mit Begründung angezeigt, statt stillschweigend falsch eingeplant zu werden.'
            },
            {
                name: 'Wunschpartner & No-Gos',
                descriptionShort: 'Wer mit wem trainieren will',
                descriptionLong:
                    'Teilnehmer geben im Anmeldeformular an, mit wem sie trainieren möchten. Sportision wertet die Angaben aus, ordnet sie den richtigen Personen zu und fragt nur nach, wenn etwas nicht eindeutig ist. Auch Kombinationen, die ausdrücklich nicht zusammen sollen, lassen sich festlegen und aus dem Vorjahr übernehmen.'
            },
            {
                name: 'Verfügbarkeiten mit Gewichtung',
                descriptionShort: '„Kann“ und „Wunschzeit“',
                descriptionLong:
                    'Teilnehmer hinterlegen, wann sie können und wann sie am liebsten trainieren. Zeiten gelten als feste Bedingung oder als weiches Kriterium, damit am Ende möglichst alle einen Platz bekommen.'
            },
            {
                name: 'Trainer-Verfügbarkeiten & Auslastung',
                descriptionShort: 'Trainer fair verteilen',
                descriptionLong:
                    'Für jeden Trainer sind Verfügbarkeiten zeitgenau hinterlegt, und niemand wird außerhalb seiner Zeiten eingeplant. Die Trainerübersicht zeigt, wer wie viele Einheiten hat und wo noch Luft ist.'
            },
            {
                name: 'Platz- & Hallenkapazitäten',
                descriptionShort: 'Plätze direkt reserviert',
                descriptionLong:
                    'Sportision verwaltet Plätze, Hallenteile und Kapazitäten zentral. Geplante Gruppen werden im Belegungsplan reserviert, Doppelbelegungen und doppelt vergebene Plätze fallen sofort auf.'
            },
            {
                name: 'Drag-&-Drop-Planung',
                descriptionShort: 'Trainingsplan visuell erstellen',
                descriptionLong:
                    'Gruppen und Teilnehmer ziehst du per Drag & Drop auf freie Zeitfenster und Plätze. Ziehst du ein Mitglied auf eine freie Fläche, entsteht dort direkt eine neue Gruppe. Kontextmenü, Kopieren und Einfügen sowie Tastenkürzel machen auch große Pläne schnell.'
            },
            {
                name: 'Verfügbarkeitsprüfung pro Gruppe',
                descriptionShort: 'Wer kann zum Termin',
                descriptionLong:
                    'Für jede Gruppe zeigt Sportision, wer zum geplanten Termin kann und wer nicht, und schlägt freie Zeitblöcke vor, in denen alle können.'
            },
            {
                name: 'Plan-Check',
                descriptionShort: 'Vor dem Versand alles geprüft',
                descriptionLong:
                    'Der Plan-Check prüft Planung, Plätze, Abrechnung und Anwesenheit und zeigt, was noch offen ist. Ist alles erledigt, kann der Plan raus.'
            },
            {
                name: 'Mehrere Planungsansichten',
                descriptionShort: 'Trainer-, Platz- und Gruppensicht',
                descriptionLong:
                    'Der Trainingsplan lässt sich aus verschiedenen Perspektiven betrachten, etwa aus Trainer-, Platz- oder Gruppensicht. So lassen sich Auslastung und Verteilung gezielt kontrollieren.'
            },
            {
                name: 'Preislisten mit Ratenzahlung',
                descriptionShort: 'Abrechnung direkt aus dem Plan',
                descriptionLong:
                    'Preise ergeben sich aus Preisregeln und Preismatrix, etwa nach Gruppengröße oder Trainer. Rechnungen lassen sich in Raten aufteilen, monatlich, vierteljährlich oder im eigenen Rhythmus. Eine Simulation zeigt vorab, was alle zahlen.'
            },
            {
                name: 'Trainingszeiten verschicken',
                descriptionShort: 'Alle Beteiligten informiert',
                descriptionLong:
                    'Steht der Plan, verschickst du die Trainingszeiten an die Teilnehmer ausgewählter Gruppen per E-Mail und App. Änderungen kommunizierst du genauso.'
            },
            {
                name: 'Vertretungen',
                descriptionShort: 'Ausfälle schnell überbrücken',
                descriptionLong:
                    'Fällt ein Trainer aus, trägst du eine Vertretung ein, ohne den Grundplan anzufassen.'
            },
            {
                name: 'Übergabe ans Trainingsjournal',
                descriptionShort: 'Termine sofort in der App',
                descriptionLong:
                    'Gruppen und Termine werden automatisch ins Trainingsjournal übernommen. Trainer haben ihre Stunden sofort in der App und erfassen dort die Anwesenheit.'
            },
            {
                name: 'Plan an anderen Verein übergeben',
                descriptionShort: 'Für Trainingsschulen mit wechselnden Standorten',
                descriptionLong:
                    'Wechselt eine Trainingsschule den Verein, übergibt sie ihren Plan per Einmal-Token. Gruppen mit Terminen, Teilnehmer mit Zeiten und Wünschen sowie Preislisten kommen mit. Rechnungen und Trainerbesetzung bleiben beim abgebenden Verein.'
            },
            {
                name: 'Änderungshistorie',
                descriptionShort: 'Wer hat was geändert',
                descriptionLong:
                    'Jede Änderung am Plan wird protokolliert. So lässt sich auch Wochen später nachvollziehen, wer eine Gruppe verschoben oder einen Teilnehmer entfernt hat.'
            }
        ],
        sections: [
            {
                title: 'Trainingsplanerstellung neu gedacht',
                description:
                    'Wenn im Herbst die Anmeldungen für das Wintertraining kommen, beginnt in vielen Vereinen das große Puzzeln mit Excel. Mit Sportision übernimmst du die Anmeldungen samt Wunschzeiten und Wunschpartnern, lässt dir Gruppen vorschlagen und verteilst Trainer und Plätze per Drag & Drop. Das System zeigt Konflikte, bevor sie entstehen, berechnet die Preise und schickt allen ihre Trainingszeiten. Ob Sportverein, Tennisschule oder Kursanbieter: Die Planung wird nachvollziehbar und lässt sich jede Saison wiederholen.',
                highlight: 'box'
            },
            {
                title: 'Grundlagen schaffen',
                description: 'Die Basis für einen funktionierenden Trainingsplan: sauber, flexibel und realistisch.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Daten zu Plätzen & Kapazitäten',
                        description:
                            'Lege Plätze, Hallenteile und verfügbare Kapazitäten zentral fest. Geplante Gruppen werden direkt im Belegungsplan reserviert.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Import aus Online-Anmeldungen',
                        description:
                            'Anmeldungen samt Wunschzeiten, Gruppengröße und Wunschpartnern übernimmst du mit dem Import-Assistenten, mit Vorschau vor der Übernahme.'
                    },
                    {
                        type: 'imageCard',
                        image: '/images/modules/bookings.png'
                    }
                ]
            },

            {
                title: 'Gruppen automatisch bilden',
                description: 'Angemeldete Teilnehmer schnell und sinnvoll zu Trainingsgruppen zusammenführen.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Gruppenvorschläge auf Knopfdruck',
                        description:
                            'Alter, Gruppengröße, Wunschzeiten, Wunschpartner und Plätze fließen in den Vorschlag ein. Wie stark jedes Kriterium zählt, entscheidest du.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Wunschpartner & No-Gos',
                        description:
                            'Freitext-Angaben aus dem Anmeldeformular werden ausgewertet und den richtigen Personen zugeordnet. Ausschlüsse lassen sich aus dem Vorjahr übernehmen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Verfügbarkeiten mit Gewichtung',
                        description:
                            'Zeiten zählen als feste Bedingung oder als Wunsch. Wer nicht passt, wird mit Begründung angezeigt.'
                    }
                ]
            },

            {
                title: 'Trainingsplan erstellen',
                description: 'Komplexe Trainingspläne einfach zusammenbauen: visuell, schnell und sicher.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Drag-&-Drop-Scheduling',
                        description:
                            'Ziehe Gruppen und Teilnehmer in freie Zeitfenster und auf verfügbare Plätze. Kopieren, Einfügen und Tastenkürzel inklusive.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Verfügbarkeitsprüfung & Plan-Check',
                        description:
                            'Pro Gruppe siehst du, wer zum Termin kann, und bekommst Alternativen vorgeschlagen. Der Plan-Check zeigt vor dem Versand, was noch offen ist.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Mehrere Ansichten',
                        description:
                            'Wechsle zwischen Trainer-, Platz- und Gruppensicht. Die Trainerübersicht zeigt die Auslastung jedes Trainers.'
                    }
                ]
            },

            {
                title: 'Automatisierung im Hintergrund',
                description: 'Wenn der Plan steht, übernimmt das System den Rest.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Preislisten mit Ratenzahlung',
                        description:
                            'Preise aus Regeln und Preismatrix, Rechnungen auf Wunsch in Raten. Eine Simulation zeigt vorab, was alle zahlen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Automatische Integration des Trainingsjournals',
                        description:
                            'Der Trainingsplan wird automatisch ins Trainingsjournal übernommen. Trainer haben ihre Stunden direkt in der App und erfassen dort Anwesenheiten und Notizen.'
                    }
                ]
            },

            {
                title: 'Kommunikation ohne Mehraufwand',
                description: 'Alle Beteiligten informieren, zuverlässig und aktuell.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Trainingszeiten verschicken',
                        description:
                            'Teilnehmer ausgewählter Gruppen erhalten ihre Trainingszeiten mit einem Klick. Änderungen im Plan kommunizierst du genauso.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'App und E-Mail Integration',
                        description:
                            'Benachrichtigungen werden per E-Mail und über die Sportision App zugestellt.'
                    }
                ]
            },

            {
                title: 'Im laufenden Betrieb',
                description: 'Auch nach dem Saisonstart bleibt der Plan beweglich.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Vertretungen',
                        description: 'Fällt ein Trainer aus, trägst du eine Vertretung ein, ohne den Grundplan zu ändern.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Änderungshistorie',
                        description: 'Jede Änderung am Plan ist protokolliert und nachvollziehbar.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Plan übergeben',
                        description:
                            'Wechselt eine Trainingsschule den Verein, nimmt sie Gruppen, Teilnehmer und Preislisten per Einmal-Token mit.'
                    }
                ]
            },

            {
                title: 'Der Mehrwert für deinen Sportbetrieb',
                description: 'Weg von Excel und Zettelwirtschaft, hin zu einer zentralen Trainingsverwaltung.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Alles in einem System',
                        description:
                            'Anmeldungen, Trainer, Plätze und die Abrechnung greifen nahtlos ineinander. Sportision ersetzt manuelle Listen und macht die Trainingsplanung planbar, transparent und skalierbar.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Zeit sparen & Fehler vermeiden',
                        description:
                            'Automatische Prüfungen, klare Strukturen und digitale Abläufe reduzieren Fehler und sparen Zeit, gerade bei großen Trainingsumfängen.'
                    }
                ]
            }
        ]
    },

    {
        title: 'Trainerstunden online anbieten',
        slug: 'trainerstunden',
        seo: {
            title: 'Trainerstunden-Buchung für Vereine | Sportision',
            description:
                'Vermarkte freie Trainerzeiten: Online-Buchungskalender, flexible Preise & integrierte Zahlung. Steigere Auslastung und deinen Umsatz. Jetzt entdecken!',
            keywords: [
                'trainerstunden online buchen',
                'tennis trainerstunden buchen',
                'tennis training online buchen',
                'einzeltraining tennis online',
                'tennis trainerstunden software',
                'tennis buchungssystem für vereine',
                'software für tennisschulen und tennisvereine',
                'online buchung für tennistraining',
                'online zahlung trainerstunden',
                'auslastung tennis trainer steigern',
                'digitale lösung für tennis trainerstunden',
                'tennis kursverwaltung online'
            ]
        },
        description:
            'Mach aus freien Zeiten echte Einnahmen. Mit Sportision werden Trainerstunden online buchbar, inklusive Zahlung und automatischer Bestätigung. Du füllst Lücken im Kalender, entlastest dein Team und bietest Mitgliedern ein modernes Buchungserlebnis, schnell, transparent und professionell.',
        image: '/images/modules/trainer_bookings.png',
        relatedSlugs: ['trainingsplanerstellung', 'trainingsjournal', 'platzbuchungen'],

        functions: [
            {
                name: 'Online-Buchungskalender für Trainer',
                descriptionShort: 'Trainerstunden digital buchbar',
                descriptionLong:
                    'Trainer können ihre freien Kapazitäten über einen digitalen Buchungskalender anbieten. Verfügbare Zeiten werden transparent dargestellt und können von Mitgliedern oder externen Nutzern direkt online gebucht werden.'
            },
            {
                name: 'Individuelle Preisregeln',
                descriptionShort: 'Flexible Preisgestaltung',
                descriptionLong:
                    'Preise lassen sich feingranular konfigurieren, abhängig von Trainer, Dauer, Trainingsform, Zielgruppe oder Tageszeit. So können unterschiedliche Angebote gezielt bepreist werden.'
            },
            {
                name: 'Buchungsregeln & Einschränkungen',
                descriptionShort: 'Regeln automatisch durchsetzen',
                descriptionLong:
                    'Sportision ermöglicht die Definition von Vorlaufzeiten, Stornofristen, Buchungslimits und Berechtigungen. Das System stellt automatisch sicher, dass alle Regeln eingehalten werden.'
            },
            {
                name: 'Online-Zahlung & SEPA-Lastschrift',
                descriptionShort: 'Zahlung direkt bei Buchung',
                descriptionLong:
                    'Trainerstunden können direkt online bezahlt werden per SEPA-Lastschrift oder über weitere Zahlungsmethoden. Zahlungen werden automatisch zugeordnet und verbucht.'
            },
            {
                name: 'Zentrale Zahlungs- & Buchungsübersicht',
                descriptionShort: 'Alle Buchungen im Blick',
                descriptionLong:
                    'Alle Trainerstunden, Buchungen und Zahlungen werden übersichtlich dargestellt und stehen strukturiert für Auswertungen sowie Abrechnungen zur Verfügung.'
            },
            {
                name: 'Automatischer Kapazitätsabgleich',
                descriptionShort: 'Keine Doppelbelegungen',
                descriptionLong:
                    'Freie Zeiten ergeben sich aus den hinterlegten Verfügbarkeiten der Trainer abzüglich bestehender Buchungen und Sperren. So entstehen keine Doppelbelegungen.'
            },
            {
                name: 'Automatische Platzverwaltung',
                descriptionShort: 'Keine Doppelbelegungen',
                descriptionLong:
                    'Bei jeder Buchung sucht Sportision automatisch einen freien Platz im Platzbuchungssystem und reserviert ihn. Doppelbelegungen werden zuverlässig vermieden.'
            },
            {
                name: 'Zusatzumsatz durch freie Kapazitäten',
                descriptionShort: 'Trainerzeiten besser auslasten',
                descriptionLong:
                    'Ungenutzte Trainerzeiten lassen sich gezielt vermarkten und monetarisieren, und zwar ohne zusätzlichen Verwaltungsaufwand sowie vollständig integriert in den Sportbetrieb.'
            },
            {
                name: 'Gutscheine & Rabatte',
                descriptionShort: 'Anreize für Buchungen schaffen',
                descriptionLong:
                    'Gutscheine und Rabattaktionen können flexibel erstellt sowie verwaltet werden. So lassen sich gezielt Anreize für Buchungen setzen und die Auslastung steigern.'
            },
            {
                name: 'App-Integration',
                descriptionShort: 'Buchen und Stunden mobil',
                descriptionLong:
                    'Mitglieder buchen Trainerstunden direkt in der Sportision App und sehen ihre Buchungen. Trainer finden die gebuchten Stunden in ihrem Trainingsjournal.'
            }
        ],
        sections: [
            {
                title: 'Trainerstunden einfach, smart und digital',
                description:
                    'Einfach Trainerstunden online buchbar machen und die Auslastung deines Trainerteams spürbar steigern: Mit Sportision verwandelst du freie Zeiten in echte Einnahmen und bietest Mitgliedern ein modernes, intuitives Buchungserlebnis. Tennisschulen und Vereine stellen ihre Trainerstunden inklusive Regeln, Preisen und Online-Zahlung zentral bereit, während Spieler in wenigen Klicks das passende Training finden, buchen und bezahlen, ganz ohne Telefonstress und Excel-Listen.',
                highlight: 'box'
            },
            {
                title: 'Kapazitäten nicht ungenutzt lassen',
                description: 'Freie Trainerkapazitäten online sichtbar machen und einfach buchbar anbieten.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Online-Buchungskalender für Trainer',
                        description:
                            'Trainer können ihre freien Kapazitäten über einen digitalen Buchungskalender anbieten. Verfügbare Zeiten werden transparent dargestellt und können von Mitgliedern oder externen Nutzern direkt online gebucht werden.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Zentrale oder direkte Buchung',
                        description:
                            'Buchungen gehen direkt ein oder zunächst als Anfrage an die Verwaltung. Dort lassen sie sich bestätigen oder ablehnen.'
                    }
                ]
            },

            {
                title: 'Flexible Preise & Buchungsregeln',
                description: 'Jede Trainerstunde individuell konfigurieren, passend zu Angebot und Zielgruppe.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Individuelle Preisregeln',
                        description:
                            'Preise lassen sich feingranular konfigurieren, abhängig von Trainer, Dauer, Zielgruppe, Tageszeit oder Trainingsform. So können Einzelstunden, Fördertraining oder Premium-Zeiten gezielt bepreist werden.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Buchungsregeln & Einschränkungen',
                        description:
                            'Definiere Vorlaufzeiten, Stornofristen, Buchungslimits oder Berechtigungen. Sportision sorgt automatisch dafür, dass alle Regeln eingehalten werden.'
                    }
                ]
            },

            {
                title: 'Zahlung & Abrechnung integriert',
                description: 'Buchung und Zahlung greifen nahtlos ineinander.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Online-Zahlung & SEPA-Lastschrift',
                        description:
                            'Trainerstunden können direkt online bezahlt werden per SEPA-Lastschrift oder über weitere Zahlungsmethoden. Zahlungen werden automatisch zugeordnet und verbucht.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Saubere Grundlage für Abrechnung',
                        description:
                            'Alle Buchungen und Zahlungen stehen strukturiert zur Verfügung und bilden die Grundlage für Trainerabrechnungen sowie Auswertungen.'
                    }
                ]
            },

            {
                title: 'Nahtlos in den Sportbetrieb integriert',
                description: 'Trainerstunden sind kein Inselsystem, sondern Teil der Sportision-Plattform.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Automatischer Kapazitätsabgleich',
                        description:
                            'Freie Zeiten ergeben sich aus den Verfügbarkeiten der Trainer, abzüglich Buchungen und Sperren. Den passenden freien Platz sucht Sportision automatisch.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Übersichtlicher Buchungskalender',
                        description:
                            'Alle Trainerstunden werden in einem zentralen Buchungskalender dargestellt. Trainer und die Verwaltung behalten jederzeit den Überblick über gebuchte sowie freie Zeiten.'
                    }
                ]
            },

            {
                title: 'Mehr Umsatz mit freien Zeiten',
                description: 'Ungenutzte Kapazitäten gezielt vermarkten.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Freie Trainerzeiten monetarisieren',
                        description:
                            'Statt ungenutzter Zeitfenster können Trainer ihre Kapazitäten aktiv anbieten und zusätzliche Einnahmen generieren ohne zusätzlichen Verwaltungsaufwand.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Ideal für Einzeltraining & Zusatzangebote',
                        description:
                            'Ob Einzeltraining, Förderstunden oder Zusatzangebote: Das Modul Trainerstunden eignet sich perfekt für flexible sowie individuell buchbare Trainingsformate im Breitensport.'
                    }
                ]
            }
        ]
    },
    {
        title: 'Reiten: die digitale Stallverwaltung für Reitanlagen',
        slug: 'reiten',
        seo: {
            title: 'Reiten & Stallverwaltung: Software für Reitställe | Sportision',
            description:
                'Software für Reitställe & Reitvereine: Pferdeakte, Boxenbelegung, Futterpläne & automatische Abrechnung der Einsteller in einem System. Jetzt entdecken!',
            keywords: [
                'reiten',
                'reitstall software',
                'reitverein software',
                'reitanlage software',
                'stallverwaltung',
                'stallverwaltung software',
                'reitstall verwaltung',
                'pferdepension software',
                'pensionspferde abrechnung',
                'einstellerverwaltung',
                'pferdeakte digital',
                'boxenverwaltung',
                'boxenplan reitstall',
                'futterplan software',
                'fütterungsliste stall',
                'hufschmied termine',
                'pferdemanagement software',
                'software für reitbetriebe'
            ]
        },
        description:
            'Die digitale Stallverwaltung für Reitanlagen, Pensionsställe und Reitvereine: Pferdeakte mit Besitzern und Reitbeteiligungen, Versorgung und Gesundheit, Boxenbelegung, versionierte Futterpläne und eine Monatsabrechnung, die sich aus dem laufenden Betrieb selbst zusammensetzt.',
        image: '/images/sports/reiten.jpg',
        relatedSlugs: ['rechnungen', 'mitgliederverwaltung', 'app'],

        functions: [
            {
                name: 'Digitale Pferdeakte',
                descriptionShort: 'Alle Daten eines Pferdes an einem Ort',
                descriptionLong:
                    'Die digitale Pferdeakte bündelt Stammdaten, Beteiligte, Versorgung, Box und Futterplan an einer Stelle. Statt in Ordnern, Whiteboards und WhatsApp-Verläufen zu suchen, sehen Stallteam und Einsteller denselben aktuellen Stand. Jede Änderung ist nachvollziehbar und bleibt dauerhaft dokumentiert.'
            },
            {
                name: 'Besitzer, Reitbeteiligung und Pfleger',
                descriptionShort: 'Mehrere Personen pro Pferd mit klaren Rollen',
                descriptionLong:
                    'An einem Pferd hängen selten nur eine Person: Besitzer, Reitbeteiligung und Pfleger werden jeweils mit eigener Rolle und eigenem Zeitraum hinterlegt. So ist immer klar, wer eintragen darf, wer informiert wird und wer am Monatsende die Rechnung bekommt, auch wenn die Reitbeteiligung im Sommer wechselt.'
            },
            {
                name: 'Versorgungskatalog des Betriebs',
                descriptionShort: 'Eigene Leistungen mit Preis und Steuersatz',
                descriptionLong:
                    'Jeder Betrieb pflegt seinen eigenen Katalog an Versorgungsarten, von der Wurmkur über das Longieren bis zum Weidegang mit Zusatzfütterung. Zu jeder Leistung gehören Preis und Steuersatz, sodass sie später ohne Nacharbeit in der Abrechnung landet. Eine mitgelieferte Vorlage nimmt euch die erste Einrichtung ab.'
            },
            {
                name: 'Versorgungseinträge und Zeitstrahl',
                descriptionShort: 'Was wann an welchem Pferd gemacht wurde',
                descriptionLong:
                    'Jede Maßnahme wird als Eintrag im Zeitstrahl des Pferdes festgehalten, mit Datum, ausführender Person und Menge. Der Zeitstrahl beantwortet die typischen Stallfragen sofort: Wann war der Schmied da, wann lief die letzte Wurmkur und wer hat die Medikamente gegeben.'
            },
            {
                name: 'Gesundheitsakte mit Sichtbarkeitssteuerung',
                descriptionShort: 'Sensible Daten nur für die richtigen Augen',
                descriptionLong:
                    'Gesundheitsereignisse wie Impfungen, Behandlungen und Medikationen laufen im selben Zeitstrahl wie die Serviceleistungen, folgen aber eigenen Rechten. Über eine Einstellung legt der Betrieb fest, wie weit die Gesundheitsdaten sichtbar sind, damit sensible Informationen nicht im ganzen Stall kursieren.'
            },
            {
                name: 'Daueraufträge für wiederkehrende Versorgung',
                descriptionShort: 'Einmal anlegen, automatisch fortschreiben',
                descriptionLong:
                    'Regelmäßige Leistungen wie Hufbearbeitung alle acht Wochen oder die tägliche Zusatzfütterung werden einmal als Dauerauftrag hinterlegt. Das System schreibt die anstehenden Termine täglich fort, sodass niemand daran denken muss, den nächsten Durchgang von Hand nachzutragen.'
            },
            {
                name: 'Fällige Aufgaben für das Stallteam',
                descriptionShort: 'Aus dem Termin wird eine Aufgabe',
                descriptionLong:
                    'Steht ein Versorgungstermin an, entsteht daraus automatisch eine Aufgabe im Aufgabenmodul. Das Stallteam arbeitet die offenen Punkte des Tages in einer einzigen Liste ab und der Betrieb sieht jederzeit, was noch aussteht.'
            },
            {
                name: 'Erledigt melden in einem Schritt',
                descriptionShort: 'Abhaken direkt in der Stallgasse',
                descriptionLong:
                    'Erledigte Maßnahmen werden mobil mit einem Tipp gemeldet. Der Eintrag wird dokumentiert, die zugehörige Aufgabe geschlossen und die Leistung für die Abrechnung vorgemerkt, alles aus derselben Aktion heraus, ohne Rückkehr ins Büro.'
            },
            {
                name: 'Externe Dienstleister verwalten',
                descriptionShort: 'Tierarzt, Schmied, Therapeut und Dentist',
                descriptionLong:
                    'Tierärzte, Hufschmiede, Physiotherapeuten und Zahnärzte werden zentral hinterlegt und an den Versorgungseinträgen vermerkt. So ist bei jeder Behandlung dokumentiert, wer sie durchgeführt hat, und die richtige Nummer ist im Notfall in Sekunden gefunden.'
            },
            {
                name: 'Ställe und Boxen abbilden',
                descriptionShort: 'Die Anlage so anlegen, wie sie steht',
                descriptionLong:
                    'Mehrere Ställe, Gebäude oder Bereiche mit ihren Boxen bilden die Anlage im System ab. Jede Box trägt ihre Nummer, ihre Eigenschaften und ihre Monatsmiete, sodass Belegung, Rundenlisten und Abrechnung auf denselben Daten aufsetzen.'
            },
            {
                name: 'Boxenbelegung und Belegungsverlauf',
                descriptionShort: 'Wer steht wo, und wer stand vorher dort',
                descriptionLong:
                    'Die Belegung zeigt für die ganze Anlage, welches Pferd in welcher Box steht und seit wann. Der Verlauf bleibt vollständig erhalten, auch für längst abgegangene Pferde, und beantwortet Rückfragen zu vergangenen Monaten ohne Suchen in alten Unterlagen.'
            },
            {
                name: 'Geplante Nachfolger und Abgangsdatum',
                descriptionShort: 'Umzüge Wochen im Voraus planen',
                descriptionLong:
                    'Der Abgang eines Pferdes wird mit einem festen Datum geplant. Zieht ein Pferd aus, endet seine Box zum vereinbarten Tag und der Nachfolger kann bereits vorher eingetragen werden. So bleibt keine Box unnötig blockiert und der Belegungsplan stimmt auch für die kommenden Wochen.'
            },
            {
                name: 'Fütterungszeiten und Futterkatalog',
                descriptionShort: 'Runden und Futterarten des Betriebs',
                descriptionLong:
                    'Der Betrieb legt seine Fütterungsrunden fest, etwa Morgen, Mittag und Abend, und pflegt den Katalog der Futterarten mit Einheit und monatlichem Zuschlag. Damit ist die Grundlage für Rationen, Rundenlisten und Abrechnung einheitlich definiert.'
            },
            {
                name: 'Versionierte Futterpläne',
                descriptionShort: 'Rationen ändern, ohne die Historie zu verlieren',
                descriptionLong:
                    'Die Ration eines Pferdes wird als Fassung mit Gültigkeitszeitraum geführt. Eine Änderung schließt die laufende Fassung ab und hängt die neue an, die alte bleibt vollständig erhalten. Damit ist jederzeit nachvollziehbar, was ein Pferd zu welchem Zeitpunkt tatsächlich bekommen hat, was bei Futterumstellungen und Tierarztfragen den Unterschied macht.'
            },
            {
                name: 'Rundenliste als Druckansicht',
                descriptionShort: 'Die Futterliste für die Stallgasse',
                descriptionLong:
                    'Für jede Fütterungsrunde entsteht eine Liste über die ganze Anlage, sortiert nach Stall und Boxennummer. Sie ist am Handy nutzbar und lässt sich ausdrucken, sodass auch Aushilfen ohne Einarbeitung die richtige Ration an der richtigen Box abgeben.'
            },
            {
                name: 'Monatsabrechnung mit Vorschau',
                descriptionShort: 'Erst prüfen, dann Rechnungen erzeugen',
                descriptionLong:
                    'Die Abrechnung fasst Boxenmiete, Versorgungsleistungen und Futterzuschläge eines Monats je Einsteller zusammen. Die Vorschau zeigt vorab genau das Ergebnis, das der Lauf erzeugen würde, sodass Unstimmigkeiten vor dem Rechnungsversand auffallen und nicht danach.'
            },
            {
                name: 'Automatischer Abrechnungslauf',
                descriptionShort: 'Rechnungen ohne Excel-Zwischenschritt',
                descriptionLong:
                    'Der Abrechnungslauf erzeugt pro Einsteller eine Rechnung im Rechnungsmodul und markiert die abgerechneten Positionen, damit nichts doppelt berechnet wird. Boxenmiete wird im Voraus, Versorgung und Futter rückwirkend abgerechnet, jeweils mit eigenem Zeitraum in der Position.'
            },
            {
                name: 'Preise zum Zeitpunkt der Leistung',
                descriptionShort: 'Spätere Preisänderungen verschieben nichts',
                descriptionLong:
                    'Beim Erfassen einer Leistung wird der gültige Preis festgehalten. Passt der Betrieb den Katalog später an, bleiben abgeschlossene Monate unverändert. Das erspart Diskussionen mit Einstellern über Beträge, die sich rückwirkend bewegt haben.'
            },
            {
                name: 'Rollen und Berechtigungen im Stall',
                descriptionShort: 'Pflegen, sehen und zahlen sind drei Dinge',
                descriptionLong:
                    'Die Rechte trennen den Stallbetrieb sauber: Wer Aufgaben abhakt, sieht deshalb noch keine Beträge, und wer die Rechnung bekommt, darf deshalb nicht am Futterplan schrauben. Verwaltung der Anlage, Tagesgeschäft und Finanzen liegen jeweils in eigenen Rechtefamilien.'
            },
            {
                name: 'Mobiler Zugriff für Team und Einsteller',
                descriptionShort: 'Pferdeakte in der Sportision App',
                descriptionLong:
                    'Stallteam und Einsteller greifen über die Sportision App auf Pferdeakte, Versorgung und Kosten zu. Eingetragen wird dort, wo die Arbeit passiert, in der Stallgasse und auf dem Hof, und nicht abends aus dem Gedächtnis am Bürorechner.'
            }
        ],
        sections: [
            {
                title: 'Pferdeakte, Box, Futter und Abrechnung in einem System',
                highlight: 'box',
                description:
                    'Reitanlagen und Pensionsställe verwalten heute meist mit Whiteboard, Excel und WhatsApp: Der Boxenplan hängt in der Sattelkammer, die Futterliste klebt an der Futterkammertür, die Wurmkuren stehen in einem Heft und am Monatsende rechnet jemand alles von Hand zusammen. Genau diese Kette bildet Sportision digital ab. Die Pferdeakte hält Besitzer, Reitbeteiligung und Pfleger mit klaren Rollen fest, die Versorgung wird dort dokumentiert, wo sie stattfindet, Boxen und Belegungen zeigen jederzeit, wer wo steht, und Futterpläne bleiben als Fassungen dauerhaft erhalten. Am Monatsende entsteht die Abrechnung aus genau diesen Daten. Für den Reitbetrieb bedeutet das weniger Rückfragen, vollständige Dokumentation und eine Rechnungsstellung, die nicht mehr von einem einzelnen Kopf abhängt.'
            },
            {
                title: 'Pferdeakte & Beteiligte',
                description: 'Ein Pferd, mehrere Menschen und trotzdem klare Zuständigkeiten.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Digitale Pferdeakte',
                        description:
                            'Stammdaten, Beteiligte, Versorgung, Box und Futterplan liegen an einer Stelle. Stallteam und Einsteller sehen denselben Stand, ohne dass jemand Listen abgleichen muss.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Besitzer, Reitbeteiligung & Pfleger',
                        description:
                            'Jede beteiligte Person bekommt eine Rolle und einen Zeitraum. Wechselt die Reitbeteiligung, ändert sich der Zugriff automatisch mit, ohne dass jemand Rechte hinterherräumt.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Rechnungsempfänger festlegen',
                        description:
                            'Pro Pferd ist hinterlegt, wer zahlt. Beträge sieht nur, wer sie auch bekommt, und der Abrechnungslauf weiß am Monatsende ohne Rückfrage, an wen die Rechnung geht.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Abgang als geplantes Datum',
                        description:
                            'Ein Abgang wird Wochen im Voraus eingetragen. Die Box wird zum vereinbarten Tag frei, der Belegungsplan stimmt auch für die Zukunft und die Historie des Pferdes bleibt erhalten.'
                    }
                ]
            },
            {
                title: 'Versorgung & Gesundheit',
                description: 'Dokumentiert wird direkt in der Stallgasse, mobil und in Sekunden.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Eigener Versorgungskatalog',
                        description:
                            'Vom Longieren über den Weidegang bis zur Wurmkur: Jede Leistung hat Preis und Steuersatz und wandert damit ohne Nacharbeit in die Abrechnung. Eine Vorlage macht den Start schnell.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Zeitstrahl pro Pferd',
                        description:
                            'Wann war der Schmied da, wann lief die letzte Impfung, wer hat das Medikament gegeben. Der Zeitstrahl beantwortet die Fragen, die sonst im Stall herumgereicht werden.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Gesundheitsdaten mit eigener Sichtbarkeit',
                        description:
                            'Behandlungen und Medikationen folgen eigenen Rechten. Der Betrieb entscheidet selbst, wie weit diese Informationen im Stall sichtbar sind.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Daueraufträge & Aufgaben',
                        description:
                            'Wiederkehrende Versorgung wird einmal angelegt und automatisch fortgeschrieben. Fällige Termine erscheinen als Aufgabe und werden mobil mit einem Tipp erledigt gemeldet.'
                    }
                ]
            },
            {
                title: 'Stall & Boxen',
                description: 'Der Boxenplan von der Sattelkammerwand, nur immer aktuell.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Ställe, Bereiche & Boxen',
                        description:
                            'Bilde deine Anlage mit mehreren Ställen und ihren Boxen ab. Jede Box trägt Nummer, Eigenschaften und Monatsmiete, auf die Belegung, Futterliste und Abrechnung gemeinsam zugreifen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Wer steht wo',
                        description:
                            'Die Belegung liest sich in einer Übersicht über die ganze Anlage hinweg. Neue Mitarbeiter und Vertretungen finden sich damit ohne Einweisung zurecht.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Vollständiger Belegungsverlauf',
                        description:
                            'Jede Box behält ihre Geschichte, auch für Pferde, die den Betrieb längst verlassen haben. Rückfragen zu vergangenen Monaten sind damit in Sekunden beantwortet.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Geplante Nachfolger',
                        description:
                            'Der nächste Einsteller wird eingetragen, bevor der aktuelle auszieht. Übergaben lassen sich planen und Leerstand wird sichtbar, bevor er entsteht.'
                    }
                ]
            },
            {
                title: 'Fütterung',
                description: 'Die Futterliste, die auch die Aushilfe am Samstag versteht.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Fütterungsrunden & Futterkatalog',
                        description:
                            'Lege deine Runden fest und pflege die Futterarten mit Einheit und monatlichem Zuschlag. Rationen, Rundenlisten und Abrechnung greifen anschließend auf dieselben Angaben zu.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Versionierte Futterpläne',
                        description:
                            'Eine Änderung schließt die laufende Fassung ab und hängt die neue an. Was ein Pferd wann bekommen hat, bleibt auch nach mehreren Futterumstellungen nachvollziehbar.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Rundenliste nach Boxennummer',
                        description:
                            'Für jede Runde entsteht eine Liste in Stallgassen-Reihenfolge, am Handy nutzbar und ausdruckbar. Die richtige Ration landet an der richtigen Box, auch ohne Einarbeitung.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Futterzuschlag pro Monat',
                        description:
                            'Zusatzfutter wird als Monatsbetrag je Futterart berechnet und ist fest am Pferd verankert. Ein Planwechsel mitten im Monat verschiebt deshalb keine Beträge.'
                    }
                ]
            },
            {
                title: 'Abrechnung',
                description: 'Am Monatsende zählt niemand mehr von Hand zusammen.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Eine Rechnung je Einsteller',
                        description:
                            'Boxenmiete, Versorgung und Futterzuschläge laufen auf einem Beleg zusammen, auch bei mehreren Pferden. Jede Position trägt Pferd und Zeitraum, damit die Rechnung ohne Nachfrage verständlich ist.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Vorschau vor dem Lauf',
                        description:
                            'Die Vorschau zeigt exakt das Ergebnis, das der Lauf erzeugen würde. Unstimmigkeiten fallen auf, bevor die Rechnungen beim Einsteller liegen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Miete im Voraus, Leistung rückwirkend',
                        description:
                            'Boxenmiete wird für den kommenden Monat berechnet, Versorgung und Futter für den vergangenen. Beides steht mit eigenem Zeitraum auf demselben Dokument.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Keine doppelten Positionen',
                        description:
                            'Abgerechnete Leistungen werden markiert. Ein zweiter Lauf im selben Monat erzeugt deshalb keine Dopplungen, auch wenn zwischendurch etwas nachgetragen wurde.'
                    }
                ]
            },
            {
                title: 'Rechte & Verantwortung',
                description: 'Pflegen, sehen und zahlen sind im Stall drei verschiedene Dinge.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Getrennte Rechtefamilien',
                        description:
                            'Anlage einrichten, Tagesgeschäft erledigen und Finanzen verantworten sind eigene Rechte. Deutlich mehr Menschen dürfen ein Pferd auf die Weide bringen als den Boxenplan umbauen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Geld nur für Zahlende',
                        description:
                            'Beträge sieht ausschließlich, wer die Rechnung bekommt. Ein Pfleger hakt Aufgaben ab, ohne Preise zu sehen. Diese Trennung ist fest im System verankert und lässt sich nicht umgehen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Modul frei zuschaltbar',
                        description:
                            'Die Stallverwaltung wird pro Verein aktiviert und lässt sich mit den übrigen Sportision-Modulen kombinieren. Reitvereine mit Reitunterricht nutzen sie zusammen mit Trainingsjournal und Mitgliederverwaltung.'
                    }
                ]
            },
            {
                title: 'Mobil im Stall',
                description: 'Erfasst wird da, wo die Arbeit passiert.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Pferdeakte in der App',
                        description:
                            'Stallteam und Einsteller öffnen Akte, Versorgung und Kosten direkt am Handy. Der Weg zurück ins Büro entfällt und damit auch das abendliche Nachtragen aus dem Gedächtnis.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Kostenübersicht für Einsteller',
                        description:
                            'Einsteller sehen die Leistungen ihres Pferdes und die daraus entstehenden Kosten. Das nimmt am Monatsende die meisten Rückfragen vorweg.'
                    }
                ]
            },
            {
                title: 'FAQ zur digitalen Stallverwaltung',
                description: 'Kurz erklärt: Boxen, Futter, Abrechnung und Datenschutz im Stallalltag.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Für wen eignet sich die Stallverwaltung von Sportision?',
                        description:
                            'Für Pensionsställe, Reitanlagen und Reitvereine, die Pferde einstellen. Betriebe mit Reitunterricht kombinieren die Stallverwaltung mit Trainingsjournal, Mitgliederverwaltung und Abrechnung im selben System.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Wie funktioniert die Abrechnung der Einsteller?',
                        description:
                            'Boxenmiete, Versorgungsleistungen und Futterzuschläge eines Monats werden je Einsteller zu einer Rechnung zusammengefasst. Die Vorschau zeigt das Ergebnis vorab, der Lauf erzeugt die Rechnungen im Rechnungsmodul und markiert die abgerechneten Positionen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Was passiert mit dem Futterplan, wenn sich die Ration ändert?',
                        description:
                            'Die laufende Fassung wird abgeschlossen und die neue angehängt. Nichts wird überschrieben, sodass jederzeit nachvollziehbar bleibt, was ein Pferd zu welchem Zeitpunkt bekommen hat.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Sehen Reitbeteiligungen und Pfleger die Kosten?',
                        description:
                            'Nein. Beträge sind ausschließlich für die hinterlegten Rechnungsempfänger sichtbar. Pfleger und Reitbeteiligungen arbeiten mit Aufgaben, Versorgung und Futterplan, ohne Preise zu sehen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Wie wird ein Pferdewechsel in der Box abgebildet?',
                        description:
                            'Der Abgang wird als Datum geplant, die Box endet zu diesem Tag und der Nachfolger kann vorher eingetragen werden. Der komplette Belegungsverlauf der Box bleibt erhalten.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Können externe Dienstleister mit dokumentiert werden?',
                        description:
                            'Ja. Tierärzte, Hufschmiede, Therapeuten und Zahnärzte werden zentral hinterlegt und an den Versorgungseinträgen vermerkt, sodass jede Behandlung ihrer ausführenden Person zugeordnet ist.'
                    }
                ]
            }
        ]
    },
    {
        title: 'Die Sportision App',
        slug: 'app',
        seo: {
            title: 'Die Sportvereins-App für Mitglieder | Sportision',
            description:
                'Verbinde deinen ganzen Sportbetrieb: Buchung, Trainingsplanung, Chat & Abrechnung in einer zentralen App. Modern, mobil und vernetzt. Jetzt entdecken!',
            keywords: [
                'sport app',
                'sportsoftware app',
                'trainingsplanung app',
                'trainingsjournal',
                'anwesenheitsverfolgung',
                'abrechnung sport',
                'breitensport software',
                'sportision app'
            ]
        },
        description:
            'Die Sportision App ist das zentrale Werkzeug für den modernen Sportbetrieb. Trainer, Organisationen und Teilnehmer greifen mobil auf Buchungen, Trainingspläne, Anwesenheiten, Trainingsdokumentation, Kommunikation und Abrechnung zu. Alle Prozesse sind miteinander verknüpft, laufen automatisiert im Hintergrund und ersetzen Excel-Listen, Zettelwirtschaft sowie externe Messenger. Die App sorgt für Transparenz, spart Zeit und schafft eine einheitliche Plattform für den gesamten Trainings- und Organisationsalltag im Breitensport.',
        image: '/images/modules/journal.png',
        relatedSlugs: ['mitgliederverwaltung', 'platzbuchungen', 'trainingsjournal', 'reiten'],
        functions: [
            {
                name: 'Visueller Belegungsplan',
                descriptionShort: 'Verfügbarkeiten auf einen Blick',
                descriptionLong:
                    'Der visuelle Belegungsplan zeigt freie und belegte Zeiten für jeden Tag, mit schnellem Wechsel durch die Woche. Plätze, Kurse und Trainings können direkt per Klick gebucht werden.'
            },
            {
                name: 'Serien- & Blockbuchungen',
                descriptionShort: 'Wiederkehrende Termine buchen',
                descriptionLong:
                    'Trainings, Kurse oder ganze Saisons lassen sich gesammelt buchen. Das sorgt für Planungssicherheit und weniger Verwaltungsaufwand.'
            },
            {
                name: 'Logikbasierte Wartelisten',
                descriptionShort: 'Automatisches Nachrücken',
                descriptionLong:
                    'Ist ein Kurs voll, rücken Teilnehmer automatisch nach oder erhalten Benachrichtigungen, sobald ein Platz frei wird.'
            },
            {
                name: 'Online-Zahlung & Guthaben',
                descriptionShort: 'Zahlung direkt bei der Buchung',
                descriptionLong:
                    'Buchungen können direkt bezahlt oder über Guthaben- und 10er-Karten verrechnet werden.'
            },
            {
                name: 'Trainingszeiten in der App',
                descriptionShort: 'Der Trainingsplan für unterwegs',
                descriptionLong:
                    'Der Trainingsplan entsteht im Web. Trainer und Teilnehmer sehen ihre Gruppen und Zeiten anschließend direkt in der App.'
            },
            {
                name: 'Persönlicher Trainer-Stundenplan',
                descriptionShort: 'Alle Einheiten im Blick',
                descriptionLong:
                    'Trainer sehen alle ihre Einheiten mit Platz und Gruppe in der App, dazu Vertretungen und offene Stunden zur Übernahme.'
            },
            {
                name: 'Digitale Anwesenheitsverfolgung',
                descriptionShort: 'Teilnahme pro Einheit erfassen',
                descriptionLong:
                    'Trainer erfassen Anwesenheiten direkt in der App als Grundlage für Statistiken sowie die Abrechnung.'
            },
            {
                name: 'Trainingsnotizen & Inhalte',
                descriptionShort: 'Training dokumentieren',
                descriptionLong:
                    'Trainer halten fest, welche Inhalte trainiert wurden. So entsteht ein digitales Trainingsjournal.'
            },
            {
                name: 'Schüler- & Trainerstatistiken',
                descriptionShort: 'Auswertungen & Transparenz',
                descriptionLong:
                    'Anwesenheitsquoten, Trainingshäufigkeiten und geleistete Stunden werden automatisch ausgewertet.'
            },
            {
                name: 'Automatische Abrechnung',
                descriptionShort: 'Abrechnung aus Trainingsdaten',
                descriptionLong: 'Auf Basis von Stunden und Preismatrizen erstellt Sportision automatisch Abrechnungen.'
            },
            {
                name: 'Gruppenchats & Kommunikation',
                descriptionShort: 'Direkter Austausch',
                descriptionLong:
                    'Trainer und Teilnehmer kommunizieren über integrierte Gruppenchats und Push-Nachrichten.'
            },
            {
                name: 'Zentrale App für den Sportbetrieb',
                descriptionShort: 'Alles in einer Anwendung',
                descriptionLong:
                    'Buchung, Planung, Training, Kommunikation und Abrechnung greifen in der Sportision App nahtlos ineinander.'
            },
            {
                name: 'Digitale Schlüssel',
                descriptionShort: 'Tür öffnen per App',
                descriptionLong:
                    'Mitglieder haben ihre digitalen Schlüssel direkt in der App und öffnen damit die Tür zur Anlage.'
            },
            {
                name: 'Buchungsanfragen verwalten',
                descriptionShort: 'Unterwegs zu- oder absagen',
                descriptionLong:
                    'Verantwortliche nehmen Buchungsanfragen direkt in der App an oder lehnen sie ab. Die Teilnehmer werden automatisch informiert.'
            },
            {
                name: 'Belege scannen',
                descriptionShort: 'Für Kassenwart und Vorstand',
                descriptionLong:
                    'Eingangsrechnungen fotografierst du direkt mit der App. Die KI liest sie aus, und der Beleg landet in der Buchhaltung.'
            },
            {
                name: 'Anmelden per QR-Code',
                descriptionShort: 'Ohne Passwort am Computer',
                descriptionLong:
                    'Am Computer meldest du dich an, indem du den QR-Code mit der App scannst.'
            }
        ],
        sections: [
            {
                title: 'Die Sportision App',
                description:
                    'Eine App für den gesamten Sportbetrieb: Buchung, Training, Kommunikation und Abrechnung vereint.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Alles an einem Ort',
                        description:
                            'Die Sportision App ist das zentrale Arbeitswerkzeug für Trainer, die Organisation sowie Teilnehmer. Statt Insellösungen bündelt sie die Buchung, Trainingsplanung, das Trainingsjournal, die Kommunikation und Abrechnung in einer einzigen Anwendung.'
                    }
                ]
            },

            {
                title: 'Buchen & Anmelden',
                description: 'Plätze, Kurse und Trainings einfach online buchen, mobil und transparent.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Visueller Belegungsplan',
                        description:
                            'Mitglieder und Teilnehmer sehen freie Zeiten Tag für Tag und buchen Plätze, Kurse oder Trainings direkt per Klick.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Serien-, Block- & Wartelistenbuchungen',
                        description:
                            'Wiederkehrende Trainings, Kurse oder komplette Saisons lassen sich gesammelt buchen. Logikbasierte Wartelisten sorgen für automatische Nachrücker und eine optimale Auslastung.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Online-Zahlung & Guthaben',
                        description:
                            'Bezahlungen erfolgen direkt online oder über Guthaben- sowie 10er-Karten. Buchung und Zahlung greifen nahtlos ineinander.'
                    }
                ]
            },

            {
                title: 'Trainingsplanung',
                description: 'Im Web geplant, in der App für alle sichtbar.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Trainingszeiten in der App',
                        description:
                            'Steht der Plan, sehen Teilnehmer ihre Gruppe und Trainingszeiten direkt in der App.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Trainer-Stundenplan',
                        description:
                            'Trainer haben alle Einheiten mit Platz und Gruppe dabei, inklusive Vertretungen und offener Stunden.'
                    }
                ]
            },

            {
                title: 'Trainingsjournal',
                description: 'Training dokumentieren, Anwesenheit erfassen und automatisch auswerten.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Anwesenheit & Trainingsnotizen',
                        description:
                            'Trainer erfassen Anwesenheiten und Trainingsinhalte direkt in der App. So entsteht ein digitales Trainingstagebuch für Gruppen und einzelne Schüler.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Schüler- & Trainerstatistiken',
                        description:
                            'Aus den erfassten Daten entstehen Auswertungen zu Anwesenheitsquoten, Trainingshäufigkeiten und geleisteten Stunden.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Abrechnung aus Trainingsdaten',
                        description:
                            'Auf Basis der dokumentierten Stunden und Preismatrizen werden Abrechnungen automatisch generiert ohne Excel.'
                    }
                ]
            },

            {
                title: 'Für Verantwortliche unterwegs',
                description: 'Vereinsarbeit, die nicht am Schreibtisch warten muss.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Buchungsanfragen verwalten',
                        description: 'Anfragen direkt in der App annehmen oder ablehnen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Belege scannen',
                        description: 'Rechnung fotografieren, die KI liest sie aus, der Beleg ist in der Buchhaltung.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Digitale Schlüssel',
                        description: 'Mitglieder öffnen die Tür zur Anlage mit dem Schlüssel in ihrer App.'
                    }
                ]
            },

            {
                title: 'Kommunikation',
                description: 'Direkte Abstimmung ohne externe Messenger.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Gruppenchats & Push-Nachrichten',
                        description:
                            'Trainer und Teilnehmer kommunizieren über integrierte Gruppenchats. Änderungen und Informationen werden per Push-Nachricht verteilt.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Weniger Rückfragen',
                        description:
                            'Automatische Informationen und eine zentrale Kommunikation reduzieren den Abstimmungsaufwand sowie Missverständnisse.'
                    }
                ]
            },

            {
                title: 'Abrechnung & Finanzen',
                description: 'Automatische Abrechnung, transparente Finanzen, direkt aus der App.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Trainer- & Kursabrechnung',
                        description:
                            'Trainerstunden, Teilnehmerzahlen und Preismatrizen bilden die Grundlage für automatische Honorar- sowie Kursabrechnungen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Rechnungen & Zahlungsübersicht',
                        description:
                            'Mitglieder haben Zugriff auf Rechnungen und können offene Beträge direkt online begleichen.'
                    }
                ]
            },

            {
                title: 'Mehrwert für den Breitensport',
                description: 'Eine App, die mit eurem Sportbetrieb wächst.',
                highlight: 'underline',
                elements: [
                    {
                        type: 'sectionCard',
                        title: 'Für Vereine, Sportschulen & Trainer',
                        description:
                            'Die Sportision App ist für den gesamten Breitensport konzipiert, von kleinen Vereinen bis hin zu komplexen Sportschulen.'
                    },
                    {
                        type: 'sectionCard',
                        title: 'Weniger Verwaltung, mehr Sport',
                        description:
                            'Automatisierte Prozesse ersetzen die Zettelwirtschaft sowie Einzellösungen für einen modernen sowie professionellen Sportbetrieb.'
                    }
                ]
            }
        ]
    }
];
